export default {
  // ── Zoo / Livestock (legacy keys — backward compat) ──────────────────────────
  sheep: "Sheep",
  cattle: "Cattle",
  goat: "Goats",
  pig: "Pigs",
  horse: "Horses",
  animal: "Animal",
  animals: "Animals",
  group: "Group",
  groups: "Groups",
  herd: "Herd",
  herds: "Herds",
  event: "Event",
  events: "Events",
  livestock_management: "Livestock Management",
  adult: "Adult",
  adults: "Adults",
  baby: "Young",
  babies: "Young",
  adult_females: "Adult Females",
  adult_males: "Adult Males",
  baby_females: "Young Females",
  baby_males: "Young Males",
  sex: "Sex",
  male: "Male",
  female: "Female",
  sex_m: "M",
  sex_f: "F",
  type_in: "Entry Type",
  type_out: "Exit Type",
  type_in_N: "Born on farm",
  type_in_A: "Purchased",
  type_in_R: "Received as gift",
  type_in_T: "Transferred",
  type_out_M: "Dead",
  type_out_V: "Sold",
  type_out_R: "Given away",
  type_out_T: "Transferred",
  type_out_S: "Lost",
  event_delivery: "Birth",
  event_eco: "Ultrasound",
  event_treatment: "Treatment",
  event_vaccination: "Vaccination",
  event_weight: "Weighing",
  event_medication: "Medication",
  event_other: "Other",
  code: "Code",
  code_bdn: "BDN Code",
  name: "Name",
  date_birth: "Date of birth",
  date_in: "Entry date",
  date_out: "Exit date",
  mother: "Mother",
  father: "Father",
  breed: "Breed",
  color: "Color",
  note: "Notes",
  eid: "EID (chip)",
  active: "Active",
  inactive: "Inactive",
  removed: "Removed",
  no_group: "No group",
  add: "Add",
  edit: "Edit",
  remove: "Remove",
  save: "Save",
  cancel: "Cancel",
  confirm: "Confirm",
  delete: "Delete",
  restore: "Restore",
  back: "Back",
  search: "Search",
  filter: "Filter",
  all: "All",
  new: "New",
  view: "View",
  select: "Select",
  loading: "Loading...",
  no_data: "No data available",
  no_animals: "No animals found",
  no_groups: "No groups found",
  no_events: "No events recorded",
  no_members: "No animals in this group",
  error_loading: "Error loading data",
  save_ok: "Saved successfully",
  save_error: "Error saving",
  delete_ok: "Deleted successfully",
  confirm_remove: "Confirm removal?",
  total: "Total",
  members: "Animals",
  age: "Age",
  years: "years",
  months: "months",
  zoo_home: "Livestock",
  animal_list: "Registry",
  group_list: "Groups",
  animal_detail: "Animal Detail",
  group_detail: "Group Detail",
  add_animal: "New Animal",
  add_group: "New Group",
  add_event: "Add Event",
  add_to_group: "Add to Group",
  move_date: "Movement Date",
  warning_species: "Warning: this feature is primarily optimised for sheep.",

  // ── Main navigation ──────────────────────────────────────────────────────────
  nav: {
    home: "Home",
    farms: "Farms",
    activityFeed: "Activity Feed",
    messages: "Messages",
    notifications: "Notifications",
    profile: "Profile",
    organization: "Organisation",
    manageOrg: "Manage Org",
    manageAllOrgs: "Manage All Orgs",
    manageSchemas: "Manage Schemas",
    accessions: "Accessions",
    accessionsElab: "Data Analysis",
    aiTagging: "AI Tagging",
    sendNotifications: "Send Notifications",
    chatAdmin: "Admin Chat",
    virtualFarms: "Virtual Farms",
    users: "Users",
    admin: "Admin",
    settings: "Settings",
    talkToPoderi: "Talk to Poderi",
    documents: "Documents",
    adminOrgs: "Organisations",
    adminVarieties: "Varieties",
    adminChat: "Chat",
    adminPlantHealth: "Plant Health",
    adminBdf: "Pesticide Database (BDF)",
    adminWeather: "Weather Stations",
    adminSpatialModel: "Spatial Model",
    adminSystemStatus: "System Status",
    credits: "Credits",
    contact: "Contact",
  },

  // ── Farm sidebar ─────────────────────────────────────────────────────────────
  farm: {
    farmHome: "Farm Home",
    fieldsAndCrops: "Fields & Crops",
    cropRotation: "Crop Rotation",
    operations: "Operations",
    weatherDss: "Weather & DSS",
    soils: "Soils",
    warehouse: "Warehouse",
    marketing: "Marketing",
    team: "Team",
    livestock: "Livestock",
    plantrec: "Plantrec",
    openData: "Open Data",
    monitoring: "Monitoring",
    defaultName: "Farm",
  },

  // ── Farm list (FarmCenterList) ───────────────────────────────────────────────
  farmList: {
    loading: "Loading...",
    error: "Error",
    retry: "Retry",
    welcome: "Welcome",
    noFarms: "No farms registered yet.",
    createFirst: "Create your first farm to get started.",
    createFirstBtn: "Create your first farm",
    newFarm: "New Farm",
    mapPanel: "Map",
    listPanel: "List",
    searchPlaceholder: "Search farm...",
    sortBy: "Sort:",
    sortName: "A-Z",
    sortArea: "Area",
    sortSync: "Last update",
    noAddress: "Address not specified",
    plots: "Plots",
    hectares: "ha",
    seasons: "Seasons",
    farmsCount: "{count} registered farms",
    title: "Farms",
  },

  // ── Profile ──────────────────────────────────────────────────────────────────
  profile: {
    title: "User Profile",
    language: "Language",
    languageDesc: "Select the interface language",
    italian: "Italiano",
    english: "English",
  },

  // ── Phenology — BBCH stage names (identity: key = EN display value) ──────────
  "winter dormancy": "Winter dormancy",
  "start bud break": "Start bud break",
  "leaf development": "Leaf development",
  "shoot development": "Shoot development",
  "inflorescence buds are closed": "Inflorescence buds are closed",
  "inflorescence buds start to swell": "Inflorescence buds start to swell",
  "corolla differentiation": "Corolla differentiation",
  "beginning of flowering": "Beginning of flowering",
  "full flowering": "Full flowering",
  "fruit set": "Fruit set",
  "fruit growth after fruit set": "Fruit growth after fruit set",
  "stone hardening 0-50%": "Stone hardening 0-50%",
  "stone hardening > 50%": "Stone hardening > 50%",
  "stone hardening 100%": "Stone hardening 100%",
  "fruit growth green olives": "Fruit growth (green olives)",
  "fruit growth yellow-green olives": "Fruit growth (yellow-green olives)",
  "veraison 5%": "Veraison 5%",
  "veraison 50%": "Veraison 50%",
  "veraison 100%": "Veraison 100%",
  "vegetative rest": "Vegetative rest",
  "bud break": "Bud break",
  "beginning leaf unfolded": "Beginning leaf unfolded",
  "5 leaves unfolded": "5 leaves unfolded",
  "inflorescence visible": "Inflorescence visible",
  "inflorescence swelling": "Inflorescence swelling",
  "flowers separating": "Flowers separating",
  "beginning of flowering (10%)": "Beginning of flowering (10%)",
  "full flowering (50%)": "Full flowering (50%)",
  "fruit set (10%)": "Fruit set (10%)",
  "fruit set (50%)": "Fruit set (50%)",
  "fruit set (100%)": "Fruit set (100%)",
  "berries groat-sized": "Berries groat-sized",
  "berries pea-sized": "Berries pea-sized",
  "berries beginning to touch": "Berries beginning to touch",
  "berries touching": "Berries touching",
  "beginning of ripening": "Beginning of ripening",
  "berries developing colour": "Berries developing colour",
  "softening of berries": "Softening of berries",
  maturation: "Maturation",

  // ── Farm detail (FarmCenterDetail) ───────────────────────────────────────────
  farmDetail: {
    loading: "Loading...",
    edit: "Edit",
    deleteFarm: "Delete farm",
    add: "Add",
    chooseModeTitle: "How do you want to manage {name}?",
    chooseModeHint:
      "Choose the management type. You can change it later in settings.",
    modeFields: "Fields & Crops",
    modeFieldsDesc: "Plots, seasons, crop operations",
    modeZoo: "Livestock",
    modeZooDesc: "Herds, animals and groups",
    modeMixed: "Both",
    modeMixedDesc: "Mixed farm with fields and livestock",
    noSeasonTitle: "No season configured",
    noSeasonHint: "To start working with the farm, create the first season.",
    createSeason: "Create season",
    panelMap: "Map",
    panelPlots: "Plots",
    panelDetails: "Details",
    legendCrops: "Crop Legend",
    traps: "Traps",
    herdsCount: "Herds ({count})",
    goToHerd: "Go to herd",
    zooPromptTitle: "Livestock activity",
    zooPromptQuestion: "Do you have animals or herds in this farm?",
    zooPromptYes: "Yes, manage livestock",
    zooPromptNo: "No, I have no animals",
    plotsCount: "Plots ({count})",
    newPlot: "New Plot",
    searchPlaceholder: "Search by name or crop...",
    viewCard: "Card view",
    viewTable: "Table view",
    createManually: "Create manually",
    createManuallyDesc: "Draw your plot on the map.",
    importFromFile: "Import from file",
    importFromFileDesc:
      "Upload a Shapefile or GeoJSON file with your already georeferenced plots.",
    noResultsFor: 'No results for "{query}"',
    addCrop: "Add crop",
    delete: "Delete",
    open: "Open",
    absent: "Absent",
    register: "Log",
    operations: "Operations",
    observations: "Observations",
    warehouse: "Warehouse",
    newGeoElement: "+ New geographic element",
    geoElementsCount: "Geographic Elements ({count})",
    newGeoElementShort: "+ New Element",
    type: "Type:",
    surveys: "Surveys →",
    farmNotFound: "Farm not found.",
    plotModalTitle: "Plot",
    back: "Back",
    next: "Next",
    saving: "Saving...",
    saveChanges: "Save Changes",
    createPlot: "Create Plot",
    geoElementModalTitle: "Geographic Element",
    cancel: "Cancel",
    createGeoElement: "Create Element",
    seasonModalTitle: "Season",
    deletePlotTitle: "Delete plot",
    deletePlotConfirm: "Delete plot {name}?",
    deletePlotCascade:
      "This will also delete the crop {season} ({crop}) associated with this plot.",
    cropFallback: "crop",
    cannotUndo: "This action cannot be undone.",
    confirmDeleteTitle: "Confirm deletion",
    deleteSeasonConfirm: "Proceed with deleting the season?",
    deleteGeoElementConfirm: "Proceed with deleting the geographic element?",
    operationModalTitle: "Crop Operation",
    observationModalTitle: "Observation",
    deleteOperationConfirm: "Proceed with deleting the operation?",
    deleteObservationConfirm: "Proceed with deleting the observation?",
    addCropModalTitle: "Add crop",
    plotLabel: "Plot:",
    cropLabel: "Crop",
    selectCropPlaceholder: "Select crop...",
    productModalTitle: "Product",
    deleteFarmConfirm: "Proceed with deleting the farm?",
    deleteProductConfirm: "Proceed with deleting the product?",
    trapFallbackTitle: "Trap",
    editTrap: "Edit Trap",
    newTrap: "New Trap",
    save: "Save",
    deleteTrapTitle: "Delete trap",
    deleteTrapConfirm: "Delete trap {name}?",
    voiceFab: "Talk to Poderi",
    plotTypeField: "Arable plot",
    plotTypeOrchard: "Orchard",
    notAvailable: "N/A",
    typeFallback: "Type {id}",
    importPlotsAction: "Import Plots",
    createObservationAction: "Create Observation",
    createOperationAction: "Create Crop Operation",
    errorCreatingSeason: "Error creating season: {msg}",
    errorCannotDeletePlot:
      'Cannot delete: plot "{name}" has {count} crops. Remove them first.',
    errorCannotDeletePlotDeps:
      "Cannot delete: the crop {season} has {parts}. Remove them first.",
    andJoiner: " and ",
    operationsCount: "{count} operations",
    operationCount: "{count} operation",
    observationsCount: "{count} observations",
    observationCount: "{count} observation",
    errorDeleteGeneric: "Error during deletion",
    errorDeletePlot: "Error deleting the plot",
    errorCreateField: "Error during creation: {msg}",
    errorDeleteGeoElement: "Error deleting the geographic element",
    errorDeleteProduct: "Error deleting the product",
    errorDeleteFarm: "Error deleting the farm",
    errorDeleteSeason: "Error deleting the season",
    errorDeleteOperation: "Error deleting the operation",
    errorDeleteObservation: "Error deleting the observation",
    breadcrumbFallback: "Detail",
  },

  // ── Field detail (FieldDetail) ───────────────────────────────────────────────
  fieldDetail: {
    loading: "Loading...",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    plants: "Plants",
    soilMissingText:
      "No soil analysis has been entered for this field. The models use a standard soil; enter your own analysis for more accurate results.",
    addSoilAnalysis: "Add analysis",
    plotCropMissingText:
      "This field has a permanent/orchard crop but the plot has never been activated as a permanent crop: data such as planting layout and cultivar must be entered on the plot.",
    activatePlotCrop: "Activate crop on plot",
    activatePlotCropModalText:
      "Select the permanent crop to activate on the plot. It's preselected from the current field's crop, but you can change it.",
    stationMissingText:
      "No specific weather station has been chosen for the farm. The nearest weather station is used; choose the most representative station to improve model results.",
    selectStation: "Select station",
    noModelsAvailable: "No model available for this crop.",
    refreshAll: "Refresh all",
    defense: "Defense",
    defenseShort: "Pest",
    noPestModels: "No defense model available for this crop.",
    plotHeader: "Plot",
    plantingTitle: "Planting",
    plantingOf: "Planting of {cultivars}",
    plantingYear: "Year {year}",
    vigourLow: "Low",
    vigourMedium: "Medium",
    vigourHigh: "High",
    vigourSuffix: "vigour",
    grassCover: "grass cover",
    noGrassCover: "no grass cover",
    plantingLayout: "Spacing {x} × {y} m — {density} plants/ha",
    noPlantingData: "No planting data",
    soilTitle: "Soil",
    soilClaySand: "Clay {clay}% · Sand {sand}%",
    soilPh: "pH {ph}",
    defaultFarm: "Farm default",
    cropRotation: "Crop rotation",
    cultivationOf: "Cultivation of {crop}",
    cultivation: "Cultivation",
    editSurface: "Edit surface",
    customGeometry: "Custom geometry",
    variety: "Variety",
    expectedYield: "Expected yield",
    yieldMissing: "Warning: no yield set",
    irrigation: "Irrigation",
    irrigationFlow: "Irrigation flow",
    notes: "Notes",
    noGeometry: "No geometry available.",
    openDataTitle: "Open Data",
    farmDataUnavailable: "Farm data not available.",
    newOperation: "New Operation",
    newObservation: "New Observation",
    editTrapModalTitle: "Edit Trap",
    cancel: "Cancel",
    save: "Save",
    selectStationModalTitle: "Select weather station",
    confirmDeleteTitle: "Confirm deletion",
    deleteFieldConfirm:
      "You are deleting the {crop} crop for the year {season} in the plot {plot}.",
    unknownCrop: "unknown crop",
    cannotUndo: "This action cannot be undone.",
    deleteAlsoPlot: "Also delete the plot {name}",
    editFieldModalTitle: "Edit Crop",
    saveChanges: "Save Changes",
    customGeoModalTitle: "Customize Geometry",
    editPlotModalTitle: "Edit Plot",
    back: "Back",
    next: "Next",
    saving: "Saving...",
    plantingDataModalTitle: "Planting Data",
    dataUnavailable: "Data not available.",
    forceRecalc: "Force recalculation",
    close: "Close",
    help: "Help",
    plotNotFound: "Plot not found.",
    cropOperationLabel: "Crop operation",
    observationLabel: "Observation",
    tabModels: "Models",
    tabData: "Data",
    tabMap: "Map",
    tabActivity: "Activity",
    tabTraps: "Traps",
    irrigationNo: "None",
    irrigationEmergency: "Manual/emergency",
    irrigationDrip: "Drip irrigation",
    irrigationSprinkler: "Sprinkler system",
    irrigationSubirrigation: "Subirrigation",
    irrigationSurface: "Surface irrigation",
    irrigationOther: "Other types",
    plotTypeOrchard: "Orchard",
    plotTypeVineyard: "Vineyard",
    plotTypeOliveGrove: "Olive grove",
    plotTypePasture: "Pasture",
    plotTypeFieldFallback: "Field",
    notAvailable: "N/A",
    cannotDeleteHasDeps: "Cannot delete: it has {deps}. Remove them first.",
    depOperations: "{count} operation(s)",
    depObservations: "{count} observation(s)",
    depPlants: "{count} plant(s)",
    errorSavingSoil: "Error saving the soil",
    layerPlotReference: "Plot (reference)",
    layerFieldCustomGeometry: "Field (custom geometry)",
    layerPlot: "Plot",
    noCropFallback: "No crop",
    popupPlotReference: "(Reference plot)",
    popupCrop: "Crop: {crop}",
    popupCustomGeometry: "(custom geometry)",
  },

  // ── Monitoring / Observations (ObservationView) ──────────────────────────────
  observation: {
    pageTitle: "Monitoring - {name}",
    farmFallback: "Farm",
    monitoringLabel: "Monitoring",
    tabObservations: "Observations",
    tabSchede: "Form Data",
    tabTraps: "Traps",
    tabAgroecologia: "Agroecology",
    tabOrobix: "Orobix",
    observationsCount: "Observations ({count})",
    tableView: "Table",
    cardView: "Card",
    download: "Download",
    newObservation: "+ New",
    noObservations: "No observations recorded.",
    addTrapviewTrap: "Add Trapview Trap",
    selectSeasonForTraps: "Select a season to view traps.",
    spadeTestsCount: "Spade Tests ({count})",
    newSpadeTest: "+ New Test",
    noSpadeTests: "No spade test recorded.",
    deleteSpadeTitle: "Delete test",
    deleteSpadeConfirm: 'Delete the test "{name}"?',
    cancel: "Cancel",
    delete: "Delete",
    observationModalTitle: "Observation",
    confirmDeleteTitle: "Confirm deletion",
    deleteObservationConfirm:
      "Are you sure you want to delete this observation?",
    credentialsSaved: "Credentials saved.",
    trapviewHint:
      "Enter your Trapview account credentials. Traps will be imported automatically.",
    username: "Username",
    usernamePlaceholder: "Trapview username",
    password: "Password",
    close: "Close",
    save: "Save",
    errorUsernamePasswordRequired: "Username and password are required.",
    errorSaving: "Error saving.",
    colType: "Type",
    colDate: "Date",
    colPlot: "Plot",
    colCrop: "Crop",
    colNotes: "Notes",
    notAvailable: "N/A",
  },
  operationsView: {
    pageTitle: "Operations - {name}",
    farmFallback: "Farm",
    operationsLabel: "Operations",
    tabPlanning: "Planning",
    tabOperations: "Operations",
    tabSchede: "Form Data",
    tabReport: "Report",
    selectSeasonForPlanning: "Select a season to view planning.",
    createSeason: "Create Season",
    operationsCount: "Field Operations ({count})",
    tableView: "Table",
    cardView: "Card",
    download: "Download",
    newOperation: "+ New",
    filterStatus: "Status",
    filterAll: "All",
    filterNone: "Executed",
    filterPlanned: "Planned",
    filterDone: "Completed",
    filterCancelled: "Cancelled",
    reset: "Reset",
    noOperations: "No operations recorded.",
    noOperationsHint: "Add field operations to track activities on the fields.",
    noOperationsReport: "No operations recorded for this season.",
    copperReportTitle: "Copper (Cu) distributed per plot — current season",
    fieldCrop: "Plot / Crop",
    copperKgHa: "kg Cu/ha",
    copperLimit: "Limit 4 kg/ha",
    exceeded: "Exceeded",
    ok: "OK",
    total: "Total",
    operationTypesByField: "Operation types per plot",
    operationModalTitle: "Field Operation",
    confirmDeleteTitle: "Confirm deletion",
    deleteItemConfirm: "Are you sure you want to delete this item?",
    cancel: "Cancel",
    delete: "Delete",
    statusNone: "Executed",
    statusPlanned: "Planned",
    statusDone: "Completed",
    statusCancelled: "Cancelled",
    colType: "Type",
    colDate: "Date",
    colStatus: "Status",
    colPlot: "Plot",
    colCrop: "Crop",
    colDetails: "Details",
    notAvailable: "N/A",
  },
  seasonSelector: {
    createSeason: "Create Season",
    selectSeason: "Select season",
    createNewSeason: "+ Create New Season",
  },
  cardField: {
    plotNoCrop: "Plot without crop",
    plants: "plants",
    typeOrchard: "Orchard",
    typeVineyard: "Vineyard",
    typeOliveGrove: "Olive Grove",
    typePasture: "Pasture",
  },
  operationObservationModal: {
    defaultTitle: "Operation",
    back: "Back",
    next: "Next",
    cancel: "Cancel",
    save: "Save",
    update: "Update",
  },
  farmCenterFormModal: {
    cancel: "Cancel",
    saveChanges: "Save Changes",
    createFarm: "Create Farm",
    editFarmTitle: "Edit Farm",
    newFarmTitle: "New Farm",
  },
  runModelGeneric: {
    refresh: "Refresh",
    loading: "Loading...",
    modelNotSupported: "Model {modelName} not supported for rendering",
    unexpectedError: "Unexpected error",
  },
  soilCard: {
    default: "Default",
    edit: "Edit",
    delete: "Delete",
    organicMatter: "Organic Matter",
    nitrogen: "Nitrogen (N)",
    phosphorus: "Phosphorus (P₂O₅)",
    potassium: "Potassium (K₂O)",
    associatedPlots: "Associated plots",
  },
  soilFormModal: {
    editTitle: "Edit Soil Analysis",
    newTitle: "New Soil Analysis",
    cancel: "Cancel",
    save: "Save",
  },
  soilForm: {
    useStandardSoil: "Use Standard Soil",
    useStandardSoilHint:
      "Quickly create an analysis with standard values (40% sand, 20% clay)",
    sampleCode: "Sample Code",
    sampleCodePlaceholder: "e.g. SOIL-2024-001",
    samplingDate: "Sampling Date",
    textureComposition: "Texture Composition",
    sand: "Sand (%)",
    clay: "Clay (%)",
    chemicalParameters: "Chemical Parameters",
    organicMatter: "Organic Matter (%)",
    totalNitrogen: "Total Nitrogen (‰)",
    phosphorus: "Phosphorus P₂O₅ (‰)",
    potassium: "Potassium K₂O (‰)",
    useForAllPlots: "Use this analysis for all farm plots.",
    associatedPlots: "Associated Plots",
    associatedPlotsHint: "Select the plots this soil analysis applies to",
    noPlotsAvailable: "No plots available",
    validation: {
      sampleCodeRequired: "Sample code is required",
      sandRequired: "Sand percentage is required",
      clayRequired: "Clay percentage is required",
      organicMatterRequired: "Organic matter is required",
      sandClaySumExceeds: "The sum of sand and clay cannot exceed 100%",
      selectPlotOrDefault: "Select at least one plot or set as default",
    },
  },
  plotForm: {
    warningInheritedPart1: "Changes to",
    warningInheritedBold: "name, geometry and surface",
    warningInheritedPart2: "will be inherited by all {count} crops:",
    namePlotLabel: "Plot Name",
    nameGeoElementLabel: "Element Name",
    namePlotPlaceholder: "E.g.: North Field, South Orchard",
    nameGeoElementPlaceholder: "E.g.: Shed, Fence",
    typeLabel: "Element Type",
    typePlaceholder: "Select type",
    stepGeometryLabel: "Geometry",
    stepGeometryDescription: "Draw the geometry on the map",
    stepDetailsLabel: "Details",
    stepDetailsDescription: "Enter the plot details",
    nameRequired: "Name is required",
    pointRequired: "Place a point on the map",
    lineRequired: "Draw a line with at least 2 points on the map",
    polygonRequired: "Draw a polygon with at least 3 points on the map",
    cropLabel: "Crop",
    cropPlaceholder: "Select crop",
    permanentCropType: "Permanent crop / Orchard",
    fieldCropType: "Arable field",
    orchardDataButton: "Planting data",
    orchardDataEditButton: "Edit planting data",
    areaLabel: "Surface (m²)",
    areaPlaceholder: "E.g.: 2.5",
    noteLabel: "Notes",
    notePlaceholder: "Additional notes...",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Description of the element...",
    missingDataModalTitle: "Missing data",
    ok: "OK",
    orchardModalTitle: "Planting data",
    confirm: "Confirm",
    areaNegative: "Surface cannot be negative",
    typeRequired: "Select an element type",
    entityLabelPlot: "plot",
    entityLabelGeoElement: "geographic element",
    loadError: "Error loading the {entity}",
    saveError: "Error while saving",
  },
  seasonForm: {
    editTitle: "Edit Season",
    newTitle: "New Season",
    modeLabel: "Mode",
    fullYearMode: "Full year",
    customMode: "Custom period",
    yearLabel: "Year",
    yearPlaceholder: "Select year",
    seasonNameLabel: "Season Name",
    seasonNamePlaceholder: "E.g.: Spring 2024, Winter 2024-2025",
    dateFromLabel: "Start Date",
    dateToLabel: "End Date",
    cancel: "Cancel",
    saving: "Saving...",
    saveChanges: "Save Changes",
    createSeason: "Create Season",
    copyStepTitle: "Copy crops from previous season",
    copyStepHint: "Select and edit the crops to copy into the new season:",
    cropPlaceholder: "Select crop",
    copyingInProgress: "Creating crops...",
    skip: "Skip",
    copySelected: "Copy selected ({count})",
    nameRequired: "Name is required",
    dateFromRequired: "Start date is required",
    dateToRequired: "End date is required",
    dateToAfterFrom: "End date must be after start date",
    overlapMessage:
      'This season overlaps with "{name}" ({from} - {to}). Seasons cannot overlap.',
    loadError: "Error loading the season",
    saveError: "Error while saving",
  },
  zooContent: {
    title: "Livestock",
    newHerd: "+ New herd",
    loading: "Loading...",
    emptyTitle: "No herd configured",
    emptyDescription: "Create your first herd to start managing your animals.",
    createFirstHerd: "Create first herd",
    capiCount: "{count} head",
    gruppiCount: "{count} groups",
  },
  productForm: {
    catalogSearchLabel: "Search catalog",
    catalogSearchPlaceholderPesti: "Search pesticide...",
    catalogSearchPlaceholderFerti: "Search fertilizer...",
    catalogExpiry: "exp.",
    catalogEmpty: "No results — enter the name manually",
    nameLabel: "Product",
    namePlaceholder: "Product name",
    dateEnterLabel: "Entry date",
    quantityLabel: "Quantity",
    uomLabel: "Unit of measure",
    costLabel: "Total cost",
    supplierLabel: "Supplier",
    supplierPlaceholder: "Supplier name",
    invoiceLabel: "Invoice/Delivery note",
    invoicePlaceholder: "Invoice number",
    dateEndLabel: "Depletion date",
    cuPercLabel: "% Copper (Cu)",
    extraFieldsTitle: "{name} - Specific data",
    recipeTitle: "Recipe / Ingredients",
    addIngredient: "+ Add ingredient",
    recipeEmpty: "No ingredients added",
    tableProduct: "Product",
    tableQuantity: "Quantity",
    tableNote: "Notes",
    selectPlaceholder: "-- Select --",
    exhausted: " (depleted)",
    notePlaceholderRow: "Notes...",
    noteLabel: "Notes",
    notePlaceholder: "Additional notes...",
    cancel: "Cancel",
    saving: "Saving...",
    saveChanges: "Save Changes",
    addProduct: "Add Product",
    errorLoading: "Error loading product",
    errorNameRequired: "Name is required",
    errorDateRequired: "Date is required",
    errorQuantityRequired: "Quantity is required and must be &gt;= 0",
    errorSaving: "Error saving",
  },
  imageLoader: {
    takePhoto: "Take photo",
    addPhoto: "Add photo",
    uploading: "Uploading {current}/{total}...",
    queuedTitle: "Images waiting to be uploaded",
    queuedCount: "{count} pending",
    progressText: "{current} / {total} photos",
    notSynced: "Not synced",
    noImages: "No images uploaded.",
    modalTitle: "Image",
    captionLabel: "Caption",
    captionPlaceholder: "Write a caption...",
    syncedWithServer: "Synced with server",
    save: "Save",
    delete: "Delete",
    sourceGallery: "gallery",
    sourceCamera: "camera",
    errorSource: "{source} error: {message}",
    errorReadingFile: '"{name}": file read error',
    errorQueueLimit:
      "Limit reached: maximum 20 images in queue. Connect to sync.",
    errorServer: '"{label}": server error',
    errorNetwork: "network error",
    errorUpload: '"{label}": {message}',
  },
  trapCard: {
    syncButton: "Update from Trapview",
    editButton: "Edit trap",
    deleteButton: "Delete trap",
    noAutoData: "No data received from the trap yet.",
    noObservations: "No detections recorded.",
    addObservation: "+ Add detection",
    add: "+ Add",
    date: "Date",
    catches: "Catches",
    notes: "Notes",
    showImage: "Show image",
    edit: "Edit",
    delete: "Delete",
    tabChart: "Chart",
    tabData: "Data",
    chartYAxis: "Adults captured",
    editObservationTitle: "Edit detection",
    newObservationTitle: "New detection",
    syncErrorDefault: "Update error",
    typeCromo: "Chromatic traps",
    typePheno: "Pheromone traps",
    typeFlytrap: "FlyTrap",
    typeOther: "Other",
  },
  trapUpsert: {
    autoBadge: "Automatic trap — data is imported automatically from Trapview.",
    nameLabel: "Name *",
    namePlaceholder: "e.g. Trap A1",
    typeLabel: "Type",
    typeCromo: "Chromatic traps",
    typePheno: "Pheromone traps",
    typeFlytrap: "FlyTrap",
    typeOther: "Other",
    pestLabel: "Insect / Pest",
    optional: "(optional)",
    pestPlaceholder: "e.g. Ceratitis capitata",
    dateLabel: "Placement date",
    fieldsLabel: "Monitored fields",
    gpsLabel: "GPS position",
    gpsHint: "(click on the map)",
    lat: "Lat",
    lon: "Lon",
    removeCoords: "Remove",
    mapHintDefault: "Click to set the position",
    trapNameFallback: "Trap",
    nameRequired: "Enter the trap name",
  },
  trapView: {
    title: "Traps ({count})",
    newTrap: "+ New Trap",
    loading: "Loading...",
    emptyTitle: "No traps for this season.",
    emptyHint: "Create the first trap to start monitoring.",
    createTrap: "Create Trap",
    editModalTitle: "Edit Trap",
    newModalTitle: "New Trap",
    cancel: "Cancel",
    save: "Save",
    deleteModalTitle: "Delete trap",
    deleteConfirmPrefix: "Delete trap",
    deleteConfirmSuffix: "?",
    cannotUndo: "This action cannot be undone.",
    delete: "Delete",
  },
  trapviewSetup: {
    statusNotConfigured: "Not configured",
    statusInvalidCreds: "Invalid credentials",
    statusConnected: "Connected",
    notConfigured: "No Trapview integration configured.",
    invalidCreds: "Invalid credentials. Update username and password.",
    credentialsSaved: "Trapview credentials saved.",
    noTrapsImported: "No traps imported yet.",
    configureTraps: "Configure traps",
    loadingDevices: "Fetching traps from Trapview…",
    errorFetchDevices: "Error fetching traps",
    devicesTitle: "Available traps — select the ones to import:",
    selectAll: "Select all",
    importButton: "Import ({count})",
    errorImportPartial: "Error on {count} trap(s)",
    connectedPrefix: "Connected ·",
    connectedSuffix: "trap(s) connected.",
  },
  schemaDataTable: {
    noData: "No data available.",
    exportCsv: "Export CSV",
    noDataForSchema: "No data for this form.",
    columns: {
      date: "Date",
      field: "Field",
      crop: "Crop",
      area: "Area (ha)",
      productName: "Product",
      amountHa: "Dose/ha",
      dose: "Dose",
      uom: "Unit",
      amountTot: "Total",
      mm: "mm",
      tillage: "Tillage",
      depth: "Depth (cm)",
      pruningType: "Pruning type",
      culture: "Cover crop",
      fertilizzante: "Fertilizer",
      quantita: "Quantity",
      totalOlives: "Sample olives",
      trapName: "Trap",
      trap: "Catches",
      stage: "Stage",
      fasemedia: "BBCH",
      result: "Result",
      production: "Yield",
      typeAmount: "Amount type",
      regNr: "Reg. no.",
      activeIngredient: "Active ingredient",
      target: "Target pest",
      interval: "Interval (days)",
      withholding: "Withholding (days)",
      pruningNotes: "Pruning notes",
    },
  },
  orobixTab: {
    loadingAcquisitions: "Loading acquisitions...",
    noAcquisitions: "No Orobix acquisition available.",
    acquisition: "Acquisition",
    selectAcquisition: "Select an acquisition…",
    loadingData: "Loading data…",
    analysisDate: "Analysis date:",
    acquisitionDate: "Acquisition date:",
    imagesCount: "{count} images",
    mapTheme: "Map theme",
    resultSummary: "{total} olives ({green} green / {black} black) — CI: {ci}",
    loadAcquisitionsError: "Error loading acquisitions",
    loadDetailError: "Error loading detail",
    themes: {
      pctBlack: "% Black olives",
      pctBlackField: "% black olives",
      countOlives: "Total olive count",
      countOlivesField: "Olive count",
      acquisitionTime: "Acquisition time",
      acquisitionTimeField: "min from start",
    },
    columns: {
      id: "ID",
      dateTime: "Date/Time",
      lat: "Lat",
      lon: "Lon",
      result: "Result",
    },
    popup: {
      image: "Image",
      olives: "Olives",
      green: "green",
      black: "black",
      pctBlack: "% black",
      colorIndex: "Color index",
      time: "Time",
    },
  },
  ganttPlanner: {
    title: "Activity Calendar",
    experimentalHint:
      "Warning: this feature is still experimental. Data might not be saved correctly; use it only for temporary or test planning. Drag operations/observations onto the timeline to schedule them.",
    availableActivities: "Available Activities",
    searchPlaceholder: "🔍 Search activities...",
    clearSearch: "Clear",
    operationsTab: "🚜 Operations ({count})",
    observationsTab: "🔬 Observations ({count})",
    defaultOperationDescription: "Crop operation",
    defaultObservationDescription: "Observation",
    noPlotsTitle: "📋 No plot available for this season.",
    noPlotsHint: "Add plots to start planning.",
    newActivity: "New Activity",
    editOperation: "Edit Operation",
    editObservation: "Edit Observation",
    newOperation: "New Operation",
    newObservation: "New Observation",
    noFieldsAlert: "No cultivated field for this plot in the selected season.",
    moveError: "Error moving: {message}",
    deleteError: "Error deleting: {message}",
    confirmDelete: 'Delete {type} "{name}"?',
    typeOperation: "operation",
    typeObservation: "observation",
    months: {
      jan: "Jan",
      feb: "Feb",
      mar: "Mar",
      apr: "Apr",
      may: "May",
      jun: "Jun",
      jul: "Jul",
      aug: "Aug",
      sep: "Sep",
      oct: "Oct",
      nov: "Nov",
      dec: "Dec",
    },
  },
  ganttTimeline: {
    view: "View:",
    day: "Day",
    week: "Week",
    month: "Month",
    year: "Year:",
    zoom: "Zoom:",
    resetView: "Reset View",
    today: "Today",
    defaultOperationLabel: "Operation",
    defaultObservationLabel: "Observation",
  },
  quadernoDiCampagna: {
    exportExcel: "Export Excel",
    loading: "Loading data...",
    noData: "No data available for the field diary.",
    notAvailable: "N/A",
    exportNotImplemented: "Excel export - not yet implemented",
    columns: {
      date: "Date",
      season: "Season",
      species: "Species",
      variety: "Variety",
      plot: "Plot",
      area: "Area",
      operation: "Operation",
      reason: "Reason",
      production: "Yield",
      product: "Product",
      uom: "Unit",
      quantity: "Quantity",
    },
  },
  plotEnrichment: {
    noData: "No open data available",
    enrichWithOpenData: "Enrich with Open Data",
    newDataAvailable: "New data available",
    update: "Update",
    hide: "Hide",
    view: "View",
    reEnrichAllData: "Re-enrich all data",
    texture: "Texture",
    sandPercent: "{value}% sand",
    clayPercent: "{value}% clay",
    elevation: "Elevation",
    metersAboveSeaLevel: "m a.s.l.",
    temperature: "Temperature",
    updateOpenDataTitle: "Update Open Data",
    newFeaturesAvailable: "New features available",
    partialUpdate: "Partial update",
    partialUpdateHint: "Query only new data (faster)",
    fullUpdate: "Full update",
    fullUpdateHint: "Re-query all data (recommended if months have passed)",
    cancel: "Cancel",
    enrichErrorPrefix: "Error during enrichment: ",
    updateErrorPrefix: "Error during update: ",
    categoryPedology: "Pedology",
    categoryElevation: "Elevation",
    categoryTemperature: "Temperature",
  },
  fieldForm: {
    geographicFieldTitle: "Geographic Field (Plot)",
    geographicDataHint: "multi-year geographic data",
    editCustomizations: "Edit Customizations",
    customizeGeometry: "Customize Geometry",
    editPlotArrow: "Edit Plot →",
    name: "Name",
    customizedM: "customized",
    surface: "Surface",
    customizedF: "customized",
    geometry: "Geometry",
    customized: "Customized",
    fromPlot: "From plot",
    cropTitle: "Crop {season} (Field)",
    cropDataHint: "crop-specific data",
    crop: "Crop",
    selectCrop: "Select crop",
    variety: "Variety",
    varietyPlaceholder: "E.g. Frantoio, Leccino...",
    notes: "Notes",
    notesPlaceholder: "Specific notes for this crop...",
    notAvailable: "N/A",
    plotTypeOrchard: "Orchard",
    plotTypeVineyard: "Vineyard",
    plotTypeOliveGrove: "Olive grove",
    plotTypePasture: "Pasture",
    plotTypeField: "Field",
    fieldNotFound: "Field not found",
    loadErrorPrefix: "Error loading data: ",
    selectCropError: "Select a crop",
    saveError: "Error saving",
    saveErrorPrefix: "Error saving: ",
    yieldHaLabel: "Expected yield (q/ha)",
    yieldHaPlaceholder: "E.g. 50",
    irrigationLabel: "Irrigation",
    irrigationNo: "None",
    irrigationEmergency: "Manual/emergency",
    irrigationDrip: "Drip irrigation",
    irrigationSprinkler: "Sprinkler system",
    irrigationSubirrigation: "Subirrigation",
    irrigationSurface: "Surface irrigation",
    irrigationOther: "Other irrigation types",
    irrigationFlowLabel: "Irrigation flow rate (l/s)",
    irrigationFlowPlaceholder: "E.g. 2",
  },
  varietyChooser: { remove: "Remove", addMore: "Add..." },
  fieldGeoForm: {
    loading: "Loading...",
    referencePlot: "Reference plot",
    plotName: "Plot name",
    plotSurface: "Plot surface",
    crop: "Crop",
    notAvailable: "N/A",
    referenceNote:
      "You can customize name and geometry only for this crop. The plot will remain unchanged.",
    cropNameLabel: "Crop name (optional)",
    cropNamePlaceholder: "E.g.: North Vineyard, South Olive Grove",
    emptyNameHint: 'If empty, the plot name will be used: "{name}"',
    geometryLabel: "Geometry (optional)",
    geometryHint:
      "Draw the specific area of this crop. If empty, the plot geometry will be used.",
    surfaceLabel: "Surface (m²)",
    surfacePlaceholder: "Auto-calculated from geometry",
    surfaceHint:
      "Automatically calculated from the drawn geometry. If you don't draw a geometry, the plot one will be used ({area}).",
    fieldNotFound: "Field not found",
    loadErrorPrefix: "Error loading: ",
    negativeSurfaceError: "Surface cannot be negative",
    saveError: "Error saving",
    saveErrorPrefix: "Error saving: ",
  },
  plotOrchardEditor: {
    variety: "Variety",
    varietyPlaceholder: "Add a name and press enter, you can add more than one",
    plantingYear: "Planting year",
    plantingYearPlaceholder: "E.g. 2005",
    vigourClass: "Vigour class",
    notSpecifiedF: "— Not specified —",
    vigourLow: "Low",
    vigourMedium: "Medium",
    vigourHigh: "High",
    naturalGrassing: "Natural grassing",
    notSpecifiedM: "— Not specified —",
    yes: "Yes",
    no: "No",
    rowDistance: "Row distance (m)",
    rowDistancePlaceholder: "E.g. 6",
    plantDistance: "Plant distance (m)",
    plantDistancePlaceholder: "E.g. 4",
    plantingDensity: "Planting density",
    plantsPerHa: "{density} plants/ha",
  },
  fieldCropTimeline: {
    all: "All",
    operations: "Operations",
    observations: "Observations",
    noItemsRegistered: "No operations or observations recorded.",
    createFirstOperation: "Create the first crop operation",
    makeFirstObservation: "Make the first observation",
    noItemsForFilter: "No items for this filter.",
    newOperation: "New Crop Operation",
    newObservation: "New Observation",
    editOperation: "Edit Operation",
    editObservation: "Edit Observation",
    confirmDeletionTitle: "Confirm deletion",
    deleteItemConfirm: "Delete this item?",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    operation: "Operation",
    observation: "Observation",
    statusPlanned: "Planned",
    statusDone: "Done",
    statusCancelled: "Cancelled",
  },
  farmCenterForm: {
    tabAnagrafica: "Registry",
    tabExtra: "Additional Data",
    tabStazione: "Weather Station",
    nameLabel: "Farm Name",
    namePlaceholder: "E.g.: Rossi Farm",
    cuaaLabel: "Tax ID (CUAA)",
    cuaaPlaceholder: "E.g.: RSSMRA80A01H501Z",
    placeLabel: "Address/Location",
    placePlaceholder: "E.g.: Florence, Tuscany",
    searching: "Searching...",
    geocode: "Geocode",
    gpsSearching: "GPS...",
    gps: "GPS",
    gpsPositionTitle: "Locate with GPS",
    mapHint: "Click on the map to enter or edit the coordinates",
    coordinatesRequired:
      "Coordinates required: click on the map or use the Geocode button.",
    noteLabel: "Notes",
    notePlaceholder: "Additional notes about the farm...",
    addStationLink: "Add farm weather station",
    addStationLaterHint:
      "If you want to add the farm station after creating the farm, you can do it from the Dss and Weather section.",
    noStationsAvailable: "No stations available.",
    newFarmDefaultName: "New Farm",
    loadErrorPrefix: "Error loading the farm",
    geocodingErrorDefault:
      "Error during geocoding. Try again or enter the coordinates manually.",
    gpsNotSupported: "Geolocation not supported by the browser.",
    gpsPermissionDenied: "GPS permission denied. Enable location in settings.",
    gpsUnavailable: "Unable to get the GPS position.",
    nameRequired: "Name is required",
    placeRequired: "Address is required",
    required: "Required",
    latInvalid: "Not valid (-90 to 90)",
    lonInvalid: "Not valid (-180 to 180)",
    missingCoordinates:
      "Missing geographic coordinates: click on the map or use Geocode (Registry tab)",
    saveError: "Error saving",
    placeRegisteredLabel: "Registered Office Address",
    practiceLabel: "What are the farming practices",
    practiceConventional: "Conventional",
    practiceTransition: "Farm in transition to Organic",
    practiceMixed: "Organic certified farm in some sectors only",
    practiceBio: "Certified Organic farm",
  },
  stationPicker: {
    nearest: "Nearest",
    noStationsAvailable: "No stations available.",
    farmCenter: "Farm center",
    station: "Station",
    noFarmCenterCoordinates: "Farm center coordinates not available",
    dataUpdated: "Data up to date",
    dailyDataUpdated: "Daily data up to date",
    dailyDataAsOf: "Daily data as of {date}",
    hourlyDataUpdated: "Hourly data up to date",
    hourlyDataAsOf: "Hourly data as of {date}",
    dailyDataMissing: "Daily data missing",
    hourlyDataMissing: "Hourly data missing",
  },
  homeView: {
    loggedInTitle: "Logged in",
    userLabel: "User: {name}",
  },
  soilsView: {
    title: "Soils - {name}",
    farmFallback: "Farm",
    addAnalysis: "Add Soil Analysis",
    noSoils: "No soil analyses present.",
    noSoilsHint:
      "Create a new analysis to start managing your farm's soil data.",
    breadcrumbSoils: "Soils",
    saveError: "Error saving. Try again.",
    deleteConfirm: 'Do you really want to delete the soil analysis "{code}"?',
    deleteError: "Error deleting.",
  },
  warehouseSection: {
    title: "Warehouse ({count})",
    archivedBadge: "{count} depleted",
    hideArchived: "Hide depleted",
    showAll: "Show all",
    addTitle: "Add",
    noProducts: "No products",
    colProduct: "Product",
    colEntry: "Entry",
    colQty: "Qty",
    colResidual: "Residual",
    movementsTitle: "Movements",
    archiveTitle: "Mark as depleted",
    editTitle: "Edit",
    deleteTitle: "Delete",
    archivedTag: "depleted {date}",
    loadLabel: "Load",
    operationFallback: "Operation",
    uomMismatchTitle: "UOM different from load",
    residualLabel: "Residual",
  },
  operationProductRow: {
    productLabel: "Product {n}",
    removeTitle: "Remove product",
    productFieldLabel: "Product",
    selectPlaceholder: "-- Select --",
    otherManual: "Other (manual entry)",
    createProductTitle: "Create new warehouse product",
    productNameLabel: "Product name",
    productNamePlaceholder: "Product name",
    totalLabel: "Total",
    unitLabel: "Unit",
    qtyHaLabel: "Qty/ha",
    stockInsufficientPrefix: "Insufficient stock: ",
    stockPrefix: "Stock: ",
    npkMissingWarning:
      "N-P-K concentration not entered: fertilizer unit calculation won't be available. Enter the percentages above or in the warehouse product.",
    reasonLabel: "Treatment reason",
    npkEnterQuantity: "Enter a quantity to calculate NPK",
    npkSummary: "NPK units/ha: {n} - {p} - {k}",
  },
  notificationsView: {
    title: "Notifications",
    notificationsCount: "{count} notifications",
    unreadCount: "{count} unread",
    markAllRead: "Mark all as read",
    openChat: "Open chat →",
    emptyLabel: "No notifications",
    emptySub: "Push notifications you receive will appear here",
    pushOnlyNative:
      "Push notifications are only available on the native app (iOS/Android)",
    tokenAcquired: "Token acquired and successfully sent to the server",
    tokenNotObtained:
      "No token obtained — check permissions in device settings",
    registerError: "Error: {error}",
    timeNow: "Now",
    timeMinAgo: "{min} min ago",
    timeHoursAgo: "{h} hours ago",
  },
  notificationAdminView: {
    title: "Send Push Notifications",
    step1Title: "1. Filter recipients",
    activeLastLabel: "Consider active in the last",
    months: "months",
    loadUsers: "Load users",
    step2Title: "2. Select recipients",
    usersDevicesCount: "{users} users, {devices} devices",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    colEmail: "Email",
    colPlatform: "Platform",
    colLastUpdate: "Last updated",
    colDevice: "Devices",
    uidFallback: "uid:{uid}",
    selectionSummary: "{users} users selected · {devices} total devices",
    noActiveUsers: "No user with an active token in the selected period.",
    step3Title: "3. Message",
    titleLabel: "Title *",
    titlePlaceholder: "E.g.: Update available",
    bodyLabel: "Text *",
    bodyPlaceholder: "Write the notification text...",
    routeLabel: "Route (optional)",
    routePlaceholder: "E.g.: /poderi/abc123",
    routeHint:
      "If specified, the app will navigate to this route when the notification is tapped",
    previewLabel: "Preview",
    previewNoTitle: "(no title)",
    previewNoBody: "(no text)",
    sendInfo: "Will be sent to {users} users ({devices} devices)",
    sendButton: "Send notification",
    errorLoadingUsers: "Error loading users",
    confirmSendSummary:
      "You are about to send the notification to {users} users ({devices} devices). Confirm?",
    errorSending: "Error sending",
    resultTitle: "Send result",
    resultSent: "Sent",
    resultFailed: "Failed",
    resultUsers: "Users",
    resultDevicesFound: "Devices found",
    newNotification: "New notification",
  },
  feedView: {
    title: "Activity Feed",
    breadcrumbHome: "Home",
    filters: "Filters",
    org: "Organization",
    allOrgs: "All",
    farm: "Farm",
    allFarms: "All",
    crop: "Crop",
    allCrops: "All",
    type: "Type",
    allTypes: "All",
    typeObservation: "Observation",
    typeOperation: "Operation",
    typeAnimal: "Animals",
    schema: "Form",
    allSchemas: "All forms",
    period: "Period",
    periodLast30: "Last 30 days",
    periodLast90: "Last 90 days",
    periodCurrentYear: "Current year",
    periodLastYear: "Last year",
    periodAll: "All dates",
    periodCustom: "Custom",
    dateFrom: "From",
    dateTo: "To",
    dateFieldUpdate: "Last update",
    dateFieldOperation: "Operation date",
    reset: "Reset",
    loading: "Loading...",
    emptyPeriod: "No activity in the selected period.",
    emptyPeriodTable: "No data in the selected period.",
    emptyPeriodMap: "No geolocated data in the selected period.",
    errorLoadFeed: "Error loading the feed",
    statusPlanned: "Planned",
    statusDone: "Completed",
    statusCancelled: "Cancelled",
    moreFields: "{name} +{n} more",
    schemaFallback: "Form #{id}",
    operationFallback: "Operation #{id}",
    animalEventFallback: "Animal event #{id}",
    timeAgoSeconds: "{n} seconds ago",
    timeAgoMinutes: "{n} minutes ago",
    timeAgoHours: "{n} hours ago",
    timeAgoDays: "{n} days ago",
    tabFeed: "Feed",
    tabTable: "Table",
    tabMap: "Map",
    tableColDate: "Date",
    tableColFarm: "Farm",
    tableColScheda: "Form",
    tableColType: "Type",
    tableColUser: "User",
    tableColNotes: "Notes",
  },
  cropRotationView: {
    title: "Crop Rotation",
    defaultFarmName: "Farm",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Farms",
    tabRotations: "Rotations",
    tabSeasons: "Seasons",
    seasonsTitle: "Seasons ({count})",
    newSeason: "New Season",
    noSeasons: "No seasons registered.",
    noSeasonsHint: "Create the first season to start tracking crops.",
    edit: "Edit",
    delete: "Delete",
    period: "Period",
    year: "Year",
    seasonModalTitle: "Season",
    deleteConfirmTitle: "Confirm deletion",
    deleteConfirmMessage: "Are you sure you want to delete this season?",
    cancel: "Cancel",
    notAvailable: "N/A",
  },
  cropRotation: {
    title: "Crop Rotation",
    addSeason: "Add Season",
    hint: "Drag crops onto the cells to assign them to plots for a season",
    availableCrops: "Available Crops",
    searchCropPlaceholder: "Search crop...",
    clearSearch: "Clear search",
    noCropsInDb: "No crops available in the database.",
    noCropsInDbHint: "Crops will be loaded from the backend.",
    noCropsFound: 'No crop found for "{query}"',
    noCropsFoundHint: "Try a different search term.",
    noCropsFoundShort: "No crop found",
    annualCropType: "Annual",
    noPlots: "No plot available.",
    noSeasons: "No season available.",
    noPlotsOrSeasonsHint: "First create plots and seasons to manage crops.",
    plot: "Plot",
    editPlot: "Edit plot",
    remove: "Remove",
    addPlot: "Add Plot",
    editAssignmentTitle: "Edit Assignment",
    cropLabel: "Crop",
    season: "Season",
    noteLabel: "Notes",
    notePlaceholder: "Additional notes...",
    save: "Save",
    editPlotTitle: "Edit Plot",
    newPlotTitle: "New Plot",
    editSeasonTitle: "Edit Season",
    newSeasonTitle: "New Season",
    selectCropTitle: "Select Crop",
    unknown: "Unknown",
    cropAlreadyAssigned:
      "This crop is already assigned to this plot for this season.",
    createAssignmentError: "Error creating the assignment",
    saveError: "Error saving",
    removeError: "Error removing",
    confirmRemoveField: "Remove {crop} from this plot?",
  },
  adminDbmngView: {
    addNewSchema: "Add new schema",
    updateVocabularies: "Update vocabularies",
    updatingVocabularies: "Updating...",
    save: "Save",
    saving: "Saving...",
    selectSchemaType: "Select the schema type to edit",
    editSchedeButton: "Edit schemas",
    mySchede: "My schemas",
    orgSchede: "Organizations' schemas",
    columnOrganization: "Organization",
    noPersonalSchede:
      "No custom schema. Create a new one or check the public ones.",
    edit: "Edit",
    delete: "Delete",
    visible: "Visible",
    hidden: "Hidden",
    typeOrganization: "Organization",
    publicSchede: "Public schemas",
    noPublicSchede: "No public schema available.",
    typePublic: "Public",
    syncHintBefore: "After saving, click",
    syncHintAfter: "to immediately see the updated schema in the app.",
    schemaProperties: "Schema Properties",
    schemaNameLabel: "Schema name",
    schemaNamePlaceholder: "Schema name...",
    filtroLabel: "Filter",
    filtroPlaceholder: "Filter value...",
    fieldsDefinition: "Fields Definition",
    loading: "Loading...",
    confirmDeleteTitle: "Confirm deletion",
    confirmDeleteTextBefore: "Do you want to delete the schema",
    confirmDeleteTextAfter: "?",
    cancel: "Cancel",
    deleting: "Deleting...",
    newSchemaNameLabel: "Schema name",
    newSchemaNamePlaceholder: "Enter the name...",
    creating: "Creating...",
    create: "Create",
    pageTitleDefault: "Schema Management",
    schedeFor: "Schemas - {caso}",
    editorTitle: "Editor: {name}",
    breadcrumbHome: "Home",
    editorFallback: "Editor",
    columnSchemaType: "Schema type",
    columnName: "Name",
    columnActive: "Active",
    columnOrder: "Order",
    columnDataType: "Data type",
    notAvailable: "N/A",
    confirmChangeVisibility: "Are you sure you want to change the visibility?",
    errorLoadingConfig: "Error loading configuration",
    errorLoadingSchede: "Error loading schemas",
    errorLoadingSchemaDetails: "Error loading schema details",
    errorChangingVisibility: "Error changing visibility",
    errorDeleting: "Error deleting",
    errorCreatingSchema: "Error creating schema",
    errorSaving: "Error saving",
    saveSuccess: "Schema saved successfully",
  },
  warehouseView: {
    title: "Warehouse",
    farmFallback: "Farm",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Farms",
    breadcrumbWarehouse: "Warehouse",
    productModalTitle: "Product",
    cancel: "Cancel",
    saving: "Saving...",
    saveChanges: "Save Changes",
    addProduct: "Add Product",
    operationModalTitle: "Crop Operation",
    confirmDeleteTitle: "Confirm deletion",
    cannotUndo: "This action cannot be undone.",
    delete: "Delete",
    errorDeletingProduct: "Error deleting the product",
  },
  marketingView: {
    title: "Marketing",
    farmFallback: "Farm",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Farms",
    breadcrumbMarketing: "Marketing",
  },
  marketingSection: {
    publicationTitle: "Publication",
    publishedOn: "Published on {date}",
    visibleInList: "visible in listing",
    directLinkOnly: "direct link only",
    notYetPublished: "Page not yet published",
    publicUrlLabel: "Public URL",
    listed: "Listed",
    unlisted: "Unlisted",
    publishing: "Publishing...",
    saveAndUpdate: "Save and update",
    saveAndPublish: "Save and publish",
    remove: "Remove",
    descriptionTitle: "Description",
    companyDescriptionLabel: "Company description",
    companyDescriptionPlaceholder: "Describe your company...",
    productsDescriptionLabel: "Products description",
    productsDescriptionPlaceholder: "Describe your products...",
    imagesTitle: "Images",
    imageGallery: "Image gallery",
    logo: "Logo",
    contactsTitle: "Contacts and social",
    emailLabel: "Email",
    phoneLabel: "Phone",
    pageUrlPlaceholder: "Page URL",
    saveMarketingData: "Save marketing data",
    autoSlugFallback: "company-name",
    errorSaving: "Error while saving: ",
    errorPublishing: "Error publishing: ",
    errorGeneric: "Error: ",
    confirmUnpublish: "Remove the public page?",
  },
  farmCenterMap: {
    viewDetails: "View Details",
  },
  teamView: {
    inviteMember: "Invite Member",
    leaveTeam: "Leave Team",
    loading: "Loading...",
    error: "Error",
    teamMembers: "Team Members",
    owner: "Owner",
    roleOwner: "Owner",
    roleGrower: "Grower",
    roleAdvisor: "Advisor",
    roleUndefined: "Undefined",
    transferOwnership: "Transfer ownership",
    remove: "Remove",
    noMembers: "No members in the team",
    pendingInvitations: "Pending Invitations",
    singleUseLink: "Single-use link",
    expires: "Expires",
    organizations: "Organizations",
    unlink: "Unlink",
    noOrgsLinked: "No organization linked",
    orgVisibilityInfo:
      "All organization members can see this farm's observation and crop operation data, according to the settings below.",
    observations: "Observations",
    observationsHint: "monitoring, traps",
    visibleToOrg: "Visible to org",
    private: "Private",
    cropOperations: "Crop operations",
    cropOperationsHint: "irrigation, fertilization, treatments…",
    saveError: "Error saving",
    readonlyHint: "Only the owner can change these settings.",
    selectOrgPlaceholder: "Select organization...",
    link: "Link",
    inviteModalTitle: "Invite Team Member",
    inviteViaLink: "Invite via link",
    inviteContacts: "Invite Contacts",
    inviteCodeDesc:
      "Generate a single-use link to share — no need to know the email. Once generated, share the link via email or WhatsApp. If you're inviting more than one person, generate one link per person.",
    inviteContactsDesc:
      "Directly add a user you already share another farm with.",
    role: "Role",
    loadingContacts: "Loading contacts...",
    noContactsAvailable:
      "No contacts available. Contacts are users you already share at least one other farm with.",
    add: "Add",
    close: "Close",
    loginEmail: "Login email",
    emailPlaceholder: "email@example.com",
    important: "Important",
    emailInviteWarning:
      "Poderi does not send the email automatically. If the user is already on Poderi, they'll see a notice as soon as they log in. If not, we recommend notifying them personally, via email or otherwise.",
    cancel: "Cancel",
    sendInvite: "Send Invite",
    linkExpiry: "Link expiry",
    oneDay: "1 day",
    sevenDays: "7 days",
    thirtyDays: "30 days",
    noExpiry: "No expiry",
    copied: "Copied!",
    copy: "Copy",
    deleteThisInvite: "Delete this invite",
    generateLink: "Generate link",
    transferModalTitle: "Transfer Ownership",
    transferConfirmPrefix:
      "Do you want to transfer ownership of the farm center to",
    transferConfirmWarning:
      "You will no longer be able to remove members or invite people.",
    confirm: "Confirm",
    removeModalTitle: "Remove member from team",
    removeConfirmPrefix: "Do you want to remove",
    removeConfirmSuffix: "from this farm's team?",
    removeConfirmDataLoss:
      "The user will lose access to the farm and all its data.",
    farmFallback: "Farm",
    breadcrumbFarms: "Farms",
    breadcrumbTeam: "Team",
    whatsappFarmFallback: "a farm",
    whatsappInviteMessage:
      "You've been invited to join the {farm} team on Poderi. Click here to accept: {link}",
    errorGeneratingLink: "Error generating link",
    errorDeleting: "Error deleting",
    confirmCancelInvitation: "Cancel this invitation?",
    genericError: "Error",
    errorLoadingContacts: "Error loading contacts",
    errorAdding: "Error while adding",
    errorRemoving: "Error during removal",
    confirmLeaveTeam: "Do you want to leave this farm's team?",
    confirmUnlinkOrg: "Unlink this organization?",
  },
  chatListView: {
    title: "Messages",
    newMessage: "New message",
    searchConversationPlaceholder: "Search conversation...",
    loadingChats: "Loading chats...",
    retry: "Retry",
    noResults: "No results",
    startConversation: "Start the conversation...",
    noMessages: "No messages",
    noChats: "No chats",
    noChatsHint: "Start a conversation with your teams or contacts",
    newConversation: "New conversation",
    farmGroupTab: "Farm group",
    directMessageTab: "Direct message",
    searchFarmGroupPlaceholder: "Search farm group...",
    noFarmsAvailable: "No farms available",
    searchContactPlaceholder: "Search contact...",
    loading: "Loading...",
    noContactsFound: "No contacts found",
    farmGroupFallback: "Farm group",
    systemSenderName: "Poderi 2.MAI",
    adminSenderFallback: "Administrator",
    directChatFallback: "Direct chat",
  },
  chatRoomView: {
    participantSingular: "participant",
    participantPlural: "participants",
    loadingMessages: "Loading messages...",
    loadPrevious: "Load previous",
    sendFailed: "Send failed",
    sending: "Sending",
    read: "Read",
    sent: "Sent",
    noMessagesStart: "No messages yet. Start the conversation!",
    writeMessagePlaceholder: "Write a message...",
    chatFallback: "Chat",
    farmGroupFallback: "Farm group",
    systemSenderName: "Poderi 2.MAI",
    adminSenderFallback: "Administrator",
    directChatFallback: "Direct chat",
    badgeFarm: "Group",
    badgeDirect: "Direct",
    badgeBroadcast: "Announcement",
    breadcrumbChat: "Chat",
  },
  chatAdminView: {
    title: "Messages — Admin",
    newBroadcastMessage: "New broadcast message",
    loading: "Loading...",
    selectedCount: "{selected}/{total} selected",
    selectAll: "All",
    selectNone: "None",
    searchNameOrEmailPlaceholder: "Search name or email...",
    subjectOptionalLabel: "Subject (optional)",
    subjectPlaceholder: "E.g.: Crop update",
    messageLabel: "Message *",
    writeMessagePlaceholder: "Write the message...",
    recipientsCount: "{count} recipients",
    send: "Send",
    sentToCount: "Sent to {sent}/{total} recipients",
    recentThreads: "Recent threads",
    refresh: "Refresh",
    searchRecipientPlaceholder: "Search recipient...",
    repliesCount: "{count} replies",
    noThreads: "No threads",
    campaignsSent: "Campaigns sent",
    noSubject: "(no subject)",
    recipientsAbbrev: "{count} rcpt.",
    noCampaigns: "No campaigns",
    selectThreadHint: "Select a thread from the list to view the conversation",
    campaignLabel: "Campaign: {subject}",
    loadingMessages: "Loading messages...",
    replyPlaceholder: "Reply...",
    sendError: "Send error",
  },
  dssView: {
    title: "DSS - Decision Support",
    weatherStation: "Weather station",
    addStation: "Add station",
    station: "Station",
    changeStation: "Change station",
    noStationBanner:
      "No weather station associated. DSS models require weather data.",
    chooseStation: "Choose station",
    myStations: "My stations",
    irrigation: "Irrigation",
    irrigationDesc:
      "Water requirement calculation, water balance and irrigation intervention management.",
    nutrition: "Fertilization",
    nutritionDesc:
      "Fertilization plans, nutrient balance and input management.",
    dashboard: "Dashboard",
    dashboardDesc:
      "Customizable panel with favorite models across multiple fields, refreshable with one click.",
    selectWeatherStation: "Select weather station",
    cancel: "Cancel",
    save: "Save",
    home: "Home",
    farms: "Farms",
    farmFallback: "Farm",
    dssBreadcrumb: "DSS",
  },
  stationWeatherPanel: {
    loadingWeatherData: "Loading weather data...",
    dataUpdated: "Data up to date",
    dataNotUpdated: "Data not up to date",
    updatedAt: "Updated on {date}",
    dataAvailablePercentage: "{percent}% of data available",
    forecastFor: "Forecast for {name}",
    historicalDataFor: "station data for the last 10 days - {name}",
    noHistoricalData: "No historical data available.",
    selectStationHint: "Select a station to view weather data.",
    dayNamesShort: "Sun,Mon,Tue,Wed,Thu,Fri,Sat",
    tempMin: "Min T",
    tempAvg: "Avg T",
    tempMax: "Max T",
    rain: "Rain",
    temperatureAxis: "Temperature (°C)",
    rainAxis: "Rain (mm)",
    weatherDataFetchError: "Error retrieving weather data",
    networkError: "Network error",
  },
  weatherStationForm: {
    editTitle: "Edit weather station",
    addTitle: "Add weather station",
    provider: "Provider",
    stationName: "Station name",
    stationId: "Station ID",
    stationPosition: "Station position",
    mapHint:
      "Click on the map to place the station, or enter coordinates manually.",
    latitude: "Latitude",
    longitude: "Longitude",
    publicKey: "Public key",
    publicKeyPlaceholder: "Public key",
    privateKey: "Private key",
    privateKeyPlaceholder: "Private key",
    username: "Username",
    usernamePlaceholder: "Username",
    password: "Password",
    passwordPlaceholder: "Password",
    dataVisibility: "Data visibility",
    accessFarm: "Farm",
    accessFarmDesc: "Visible to teams of farms that use it",
    accessOrg: "Org",
    accessOrgDesc: "Visible to selected organizations",
    accessPublic: "Public",
    accessPublicDesc: "Visible to all users",
    accessPrivate: "Private",
    accessPrivateDesc: "Only you",
    providerPesslDesc: "Public + private key",
    providerNetsensDesc: "Username + password",
    shareWithOrgs: "Share with organizations",
    shareWithOrgsHint:
      "Select the organizations that will be able to see this station.",
    noOrgsAvailable:
      "No organization available. You must belong to at least one organization to use this option.",
    historicalDataRecovery: "Historical data recovery",
    historicalDataRecoveryHint:
      "Optional. If the station has past data, specify from when to retrieve it. It will run on first sync.",
    recoverDataFrom: "Recover data from",
    cancel: "Cancel",
    update: "Update",
    saveStation: "Save station",
    station: "Station",
    farm: "Farm",
    requiredFieldsError: "Fill in all required fields (name, coordinates).",
    stationIdRequiredError: "Station ID is required.",
    pesslKeysRequiredError: "Enter public and private key for METOS/PESSL.",
    netsensCredentialsRequiredError: "Enter username and password for Netsens.",
    saveError: "Error saving",
  },
  stationManager: {
    noOwnStations: "No station created by you.",
    edit: "Edit",
    public: "Public",
    private: "Private",
  },
  operationObservationForm: {
    invalidTypeTitle: "Invalid type",
    invalidTypeValue:
      "The value {type} is not a valid type for this component.",
    invalidTypeValid: "Valid types:",
    selectType: "Select {typeLabel}",
    selectField: "Select Field",
    changeType: "Change {typeLabel}",
    season: "Season",
    fieldSelectLabel: "Field (select one or more fields)",
    allFields: "All",
    colField: "Field",
    colCrop: "Crop",
    colAreaHa: "Area (ha)",
    notAvailable: "N/A",
    fieldsSelectedCount: "{count} field(s) selected",
    totalSurface: "Total surface",
    treatPartialSurface: "Treat only part of the surface",
    surfacePercHint: "→ {ha} ha ({perc}%) of {totalHa} ha total",
    fields: "Fields",
    surface: "Surface",
    surfacePercOf: "({perc}% of {totalHa} ha)",
    changeFields: "Change Fields",
    date: "Date",
    warning: "Warning",
    futureDateWarning:
      "the selected date is in the future. Make sure it is correct.",
    plannedActivity: "Planned activity",
    plannedActivityHint:
      "the date is in the future, this operation will be saved as planned.",
    completionLabelPrefix: "This operation is",
    plannedLower: "planned",
    completionLabelSuffix: "and not yet performed.",
    markCompleted: "Mark as completed",
    cancelActivity: "Cancel activity",
    statusWillUpdate: "the status will be updated on save.",
    undoChange: "Undo change",
    trap: "Trap",
    newTrap: "New trap",
    addTrap: "Add trap",
    selectTrapPlaceholder: "Select a trap...",
    cancel: "Cancel",
    save: "Save",
    waterQuantity: "Water quantity (l/ha)",
    waterQuantityPlaceholder: "e.g. 500",
    products: "Products",
    totalArea: "Total area",
    addAnotherProduct: "Add another product",
    harvestQuantity: "Harvest quantity",
    unitOfMeasure: "Unit of measure",
    uomQuintals: "q (quintals)",
    uomTonnes: "t (tonnes)",
    uomGrams: "g (grams)",
    uomLiters: "l (liters)",
    totalQuantity: "Total quantity",
    quantityPerHectare: "Quantity per hectare",
    surfaceAutoCalcHint:
      "Surface: {ha} ha — edit one field to auto-calculate the other.",
    quantity: "Quantity",
    olivFlyCountTitle: "Sting count - Olive fly",
    olivFlyFullCountTitle: "Stage count - Full olive fly",
    notes: "Notes",
    notesPlaceholder: "Additional notes...",
    newProduct: "New Product",
    selectAtLeastOneField: "Select at least one field",
    dateRequired: "Date is required.",
    selectOrCreateTrap: "Select a trap or create a new one with the + button",
    saveError: "Error saving: {error}",
    operationFallbackName: "Operation {id}",
    observationFallbackName: "Observation {id}",
    statusPlanned: "Planned",
    statusDone: "Completed",
    statusCancelled: "Cancelled",
    typeLabelOperation: "Crop Operation",
    typeLabelObservation: "Observation",
  },
  addPlotsView: {
    back: "Back",
    title: "Import Plots",
    dropTitle: "Drag the file here",
    dropHintWktColumn: "WKT column, EPSG:3003",
    dropHintPcgStrongPrefix:
      "It is strongly recommended to upload data from the",
    dropHintPcgStrong: "PCG (Graphic Crop Plan)",
    dropHintPcgSuffix: "for maximum future compatibility.",
    dropHintFieldsPrefix:
      "If other formats are used, it is recommended to include the field",
    dropHintFieldsNome: "(plot name) and the field",
    dropHintFieldsColtura:
      "(crop name): this way plots will be automatically configured already at import time.",
    dropHintMuted:
      "If the data isn't available, you can draw the polygons and add the information later.",
    selectFile: "Select file",
    warningsTitle: "Warnings:",
    analyzingFile: "Analyzing file...",
    crsNotFoundTitle: "Projection not found",
    crsNotFoundText1:
      "The file doesn't contain coordinate reference system information.",
    crsNotFoundText2:
      "Select the correct projection to proceed with the import.",
    crsOther: "Other",
    crsCustomPlaceholder: "e.g. 32632",
    crsCentralNorthItaly: "Central-northern Italy",
    crsCentralSouthItaly: "Central-southern Italy",
    crsDecimalDegrees: "decimal degrees",
    cancel: "Cancel",
    continue: "Continue",
    plotsCount: "{count} plots",
    withCropCount: "{count} with crop",
    importCount: "Import {count} plots",
    createFieldsLabel: "Also create crops (assign crops to plots)",
    detectedYear: "Year detected from file:",
    seasonLabel: "Season",
    selectSeasonPlaceholder: "Select season",
    createNewSeason: "Create new season",
    seasonNamePlaceholder: "Season name (e.g. 2026)",
    create: "Create",
    chooseCropPerPlotHint:
      "The crop must be chosen for each plot in the table.",
    useAsName: "Use as name:",
    defaultNamePattern: "Plot 1, 2, 3…",
    selectDeselectAll: "Select/deselect all",
    colName: "Name",
    colArea: "Area (m²)",
    colCrop: "Crop",
    colNote: "Notes",
    colGeometryTitle: "Geometry / Explode multipolygon",
    namePlaceholder: "Name",
    searchCropPlaceholder: "Search crop...",
    zoomToPolygon: "Zoom to polygon",
    explodeIntoPolygons: "Explode into {count} single polygons",
    importCompletedTitle: "Import completed",
    plotsImported: "{count} plots imported.",
    fieldsCreated: "{count} crops created.",
    backToFarm: "Back to farm",
    fileTooLarge:
      "The file is too large ({size} MB). Maximum allowed size: 10 MB.",
    errorPrefix: "Error: {message}",
    csvParseError: "Error parsing CSV.",
    noPlotsFound: "No plots found in the file.",
    invalidJsonFile: "Invalid JSON file.",
    serverError: "Server error.",
    plotDefaultName: "Plot {n}",
    cropUnknownNote: "crop?: {code}",
    seasonNameRequired: "Enter a name for the season.",
    seasonCreateError: "Error creating season.",
    selectSeasonOrDeselectAlert:
      'Select a season to create crops, or uncheck "Also create crops".',
    unnamed: "Unnamed",
  },
  plotEnrichmentView: {
    pageTitle: "Open Data Enrichment - {farm}",
    defaultFarmName: "Farm",
    updateOutdated: "Update Outdated ({count})",
    enrichAll: "Enrich All",
    stop: "Stop",
    processingInProgress: "Processing in progress...",
    plotsCompleted: "{done} / {total} plots completed",
    processingPlot: "Processing: {name}",
    plotFallbackName: "Plot {id}",
    totalPlots: "Total plots",
    enriched: "Enriched",
    outdated: "Outdated",
    notEnriched: "Not enriched",
    colPlot: "Plot",
    colStatus: "Status",
    colVersion: "Version",
    colEnrichedOn: "Enriched on",
    colActions: "Actions",
    enrich: "Enrich",
    update: "Update",
    plotsSelected: "{count} plots selected",
    enrichSelected: "Enrich Selected",
    deselectAll: "Deselect all",
    enrichmentDetailsTitle: "Enrichment Details",
    enrichmentDataTab: "Enrichment Data",
    rawJsonTab: "Raw JSON",
    statusProcessing: "Processing...",
    statusError: "Error",
    statusCompleted: "Completed",
    statusNotEnriched: "Not enriched",
    statusOutdated: "Outdated",
    statusUpdated: "Updated",
    noDataAvailable: "No data available",
    jsonParseErrorPrefix: "Error parsing JSON: {message}",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Farms",
    breadcrumbEnrichment: "Open Data Enrichment",
  },
  irrigationView: {
    title: "Irrigation",
    defaultFarmName: "Farm",
    tabModel: "Model",
    tabSensors: "Sensors",
    noSeasonAvailable: "No season available. Create a season to get started.",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Farms",
    breadcrumbDss: "Dss",
    breadcrumbIrrigation: "Irrigation",
    configTitle: "Irrigation",
    colPlot: "Plot",
    colCrop: "Crop",
    colDeficit: "Deficit (mm)",
    colAlert: "Alert",
    colLastIrrigation: "Last irrigation",
    popupDeficit: "Deficit",
    operationLabel: "Irrigate",
    operationModalTitle: "Record irrigation",
    fieldQuantity: "Quantity (mm)",
  },
  nutritionView: {
    title: "Fertilization",
    defaultFarmName: "Farm",
    noSeasonAvailable: "No season available. Create a season to get started.",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Farms",
    breadcrumbDss: "Dss",
    breadcrumbNutrition: "Fertilization",
    configTitle: "Fertilization",
    colPlot: "Plot",
    colCrop: "Crop",
    colAlert: "Alert",
    colLastFertilization: "Last fertilization",
    operationLabel: "Fertilize",
    operationModalTitle: "Record fertilization",
  },
  modelFarmSection: {
    loadingFields: "Loading Plots...",
    noFieldsFound: "No field found for this season.",
    noSoilAnalysis: "No soil analysis configured.",
    addSoilAnalysis: "Add soil analysis",
    dssNotAvailable:
      "DSS not available for the selected crop. The farm map is still available for viewing.",
    tabMap: "Map",
    noFieldsWithGeometry: "No plot with available geometry.",
    noSoilAnalysisDetail:
      "No soil analysis configured. Models use soil data for more accurate calculations.",
    summaryFields: "Fields",
    summaryIncompatible: "Incompatible",
    summaryCompleted: "Completed",
    summaryCritical: "Critical",
    summaryInProgress: "In progress",
    refreshAll: "Update all",
    stop: "Stop",
    tabTable: "Table",
    modelNotAvailable: "Model not available",
    defaultOperationLabel: "Record",
    colPlot: "Plot",
    colCrop: "Crop",
    colAlert: "Alert",
    colLastOperation: "Last op.",
    colActions: "Actions",
    unknownError: "Unknown error",
    defaultOperationModalTitle: "Record operation",
  },
  irriRender: {
    updatedAt: "Updated as of {date}",
    last7Days: "Last 7 days",
    etcAvg: "Average ETc",
    etcCumulative: "Cumulative ETc",
    rain: "Rain",
    season: "Season",
    startDate: "Start date",
    endDate: "End date",
    waterStressDays: "Water stress days",
    daysPlural: "days",
    daysSingular: "day",
    autoIrrigations: "Automatic irrigations",
    performedIrrigations: "Performed irrigations",
    settings: "Settings",
    autoIrrigation: "Automatic irrigation",
    autoIrrigationHelp:
      "When enabled, the model will automatically simulate the recommended irrigation interventions.",
    autoIrrigationMm: "Auto irrigation (mm)",
    performedIrrigationMm: "Performed irrigation (mm)",
    colDate: "Date",
    colPhenology: "Phenology",
    colCriticalThreshold: "Critical threshold",
    colOptimalThreshold: "Optimal threshold",
    colDeficit: "Deficit",
    colRainMm: "Rain (mm)",
    colAdvice: "Advice",
    chartBalance: "Balance",
    chartRain: "Rain",
    irrigateAmount: "Irrigate {amount} mm",
  },
  nutriRender: {
    colItem: "Item",
    colInputs: "Inputs (kg/ha)",
    colOutputs: "Outputs (kg/ha)",
    yieldNotSet: "Yield not set — the model uses a default value (50 q/ha).",
    editField: "Edit field",
    nutrientBalance: "Nutrient balance",
    recommendedDose: "Recommended dose: {value} kg/ha",
    applied: "Applied: {value} kg/ha",
    excess: "Excess: {value} kg/ha",
    missing: "Missing: {value} kg/ha",
    fertilizations: "Fertilizations",
    add: "Add",
    noFertilizationRegistered: "No fertilization registered.",
    colDate: "Date",
    colProduct: "Product",
    colQuantity: "Quantity",
    totals: "Totals",
    fertilization: "Fertilization",
    confirmDeleteTitle: "Confirm deletion",
    confirmDeleteText: "Delete this fertilization from",
    deleteCannotBeUndone: "This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
    balance: "Balance",
    nitrogen: "Nitrogen (N)",
    rainInputs: "Rain inputs",
    previousCrop: "Previous crop",
    previousOrgFert: "Previous organic fert.",
    mineralization: "Mineralization",
    greenManure: "Green manure",
    cropRequirement: "Crop requirement",
    leaching: "Leaching",
    volatilization: "Volatilization",
    denitrification: "Denitrification",
    phosphorus: "Phosphorus (P)",
    soilInputs: "Soil inputs",
    potassium: "Potassium (K)",
  },
  waterSensorViewer: {
    from: "From",
    loading: "Loading…",
    refresh: "Refresh",
    noSensorData: "No sensor data for the station in the indicated period.",
    soilMoistureComparison: "Soil moisture comparison — all units",
    units: "Units",
    unitName: "Unit {id}",
    showAllSeries: "Show all",
    hideAllSeries: "Hide all",
    toggleSeriesHint: "Show/hide in the chart",
    soilTempA: "Soil temp A",
    soilTempB: "Soil temp B",
    leafA: "Leaf A",
    leafB: "Leaf B",
    radiation: "Radiation",
    colDateTime: "Date/time",
    stationNotConfigured: "Weather station not configured for this farm.",
    loadError: "Loading error",
    downloadCsv: "Download CSV",
    configureSensors: "Configure sensors",
    configureSensorsTitle: "Sensor unit configuration",
    colUnit: "Unit",
    colActive: "Active",
    colName: "Name",
    colLat: "Lat",
    colLon: "Lon",
    save: "Save",
    saveAll: "Save all",
    close: "Close",
    delete: "Delete",
    addUnit: "Add unit",
    addUnitPlaceholder: "Unit ID",
    noUnitsConfig: "No units found for this station.",
    saveError: "Error while saving",
    hasDataHint: "Has data",
    noDataHint: "No data received",
    tabChart: "Chart",
    tabMap: "Map",
    tabRadiation: "Shading",
    shadingComparison: "Shading — unit radiation (shade) vs station (full sun)",
    shadingPercent: "% shading",
    positionTitle: "Position unit {id}",
    positionHint:
      "Click on the map to set the sensor coordinates. The red dot is the station, the blue one is the sensor.",
    stationMarker: "Station",
  },
  sensorMap: {
    noGeoUnits: "No units with configured coordinates.",
    unitFallbackName: "Unit {id}",
    dateLabel: "Date",
    sensorTypeLabel: "Sensor",
    wvcA: "Water content A",
    wvcB: "Water content B",
    noValue: "No data",
    noDataForDate: "{count} units with no data for the selected date.",
  },
  orgAdminView: {
    pageTitlePrefix: "Manage Org -",
    organization: "Organization",
    selectOrgPlaceholder: "Select Org...",
    members: "members",
    settings: "Settings",
    inviteUser: "Invite User",
    loading: "Loading...",
    errorPrefix: "Error:",
    selectOrgToManage:
      "Select an organization from the menu above to manage it.",
    usersWithoutPeopleProfile: "Users without a People profile",
    creating: "Creating...",
    createMissingProfiles: "Create missing profiles",
    invitationsSentPending: "Invitations Sent — Awaiting Response",
    invitedBy: "invited by",
    cancel: "Cancel",
    pendingMembershipRequests: "Pending Membership Requests",
    accept: "Accept",
    reject: "Reject",
    searchMembersPlaceholder:
      "Search by name, email, tag, admin, advisor, member…",
    farmSingular: "farm",
    farmPlural: "farms",
    roleMember: "Member",
    roleAdvisor: "Advisor",
    roleAdmin: "Admin",
    roleExternal: "External",
    pendingActivation: "awaiting first login",
    pendingActivationTitle: "User created but has not logged in yet",
    tagsPlaceholder: "e.g. class 3B, province PI (comma separated)",
    addTags: "+ tag",
    colTags: "Tags",
    cannotChangeOwnRole: "You cannot change your own role",
    you: "you",
    removeFromOrgTitle: "Remove from organization",
    noMembersFound: "No members found",
    farms: "Farms",
    newFarm: "+ New",
    searchFarmsPlaceholder: "Search farms...",
    showAllTitle: "Show all",
    onlyWithoutMembersTitle: "Only without members",
    all: "All",
    withoutTeam: "Without team",
    owner: "Owner",
    removeFromTeamTitle: "Remove from team",
    transferOwnershipTitle: "Transfer ownership",
    confirmTransferOwnershipPre: "Make",
    confirmTransferOwnershipMid: "owner of the farm",
    noMembers: "No members",
    noFarmsFound: "No farms found",
    importIntro:
      "Enter data directly in the table or paste from Excel (Ctrl+V). Press <strong>Verify</strong> to check the data, then <strong>Import</strong> to save.",
    importFarms: "Import Farms",
    reset: "Reset",
    verifying: "Verifying...",
    verify: "Verify",
    importing: "Importing...",
    import: "Import",
    row: "Row",
    importMembers: "Import Technicians / Users",
    selectRoleTitle: "Select Role",
    farmLabel: "Farm:",
    roleOwner: "Owner",
    roleGrower: "Grower",
    roleConsultant: "Consultant",
    confirm: "Confirm",
    removeFromTeamModalTitle: "Remove from Team",
    confirmRemoveFromTeamPre: "Do you want to remove",
    confirmRemoveFromTeamMid: "from the team of",
    remove: "Remove",
    removeMemberModalTitle: "Remove Member",
    confirmRemoveMemberPre: "Do you want to remove",
    confirmRemoveMemberPost: "from the organization?",
    removeMemberAlsoFromTeams:
      "They will also be removed from the teams of the organization's farms.",
    orgSettingsTitle: "Organization Settings",
    name: "Name",
    shortName: "Short name",
    description: "Description",
    publiclyVisible: "Publicly visible",
    acceptMembershipRequests: "Accept membership requests",
    save: "Save",
    inviteUserToOrgTitle: "Invite User to Organization",
    email: "Email",
    emailPlaceholder: "email@example.com",
    sendInvite: "Send Invite",
    colFarmName: "Farm Name",
    colTown: "Operating office",
    colRegisteredOffice: "Registered office",
    colLat: "Lat",
    colLon: "Lon",
    colPractice: "Practice",
    colNote: "Notes",
    colEmail: "Email",
    colFirstName: "First name",
    colLastName: "Last name",
    colMobile: "Mobile",
    colType: "Type",
    tabManagement: "Management",
    tabMap: "Map",
    tabFarms: "Farms",
    tabImport: "Import",
    colFarm: "Farm",
    colLocation: "Location",
    colArea: "Area (ha)",
    colPlots: "Plots",
    colCrops: "Crops",
    colAnimals: "Animals",
    colLastSync: "Last Sync",
    colTeam: "Team",
    filterByTechnician: "Filter by technician",
    allTechnicians: "All technicians",
    edit: "Edit",
    tabTechnicians: "Technicians",
    colName: "Name",
    colProfile: "Profile",
    colRole: "Role",
    colFarms: "Farms",
    colLastAccess: "Last access",
    breadcrumbHome: "Home",
    membersImportHelp:
      'Email, first name and last name are required. Role: leave empty for a plain member, or type "advisor" (organization agronomists) or "external" (external public bodies for reviews).',
    breadcrumbOrganizations: "Organizations",
    breadcrumbOrgManagement: "Org Management",
    roleUndefined: "Undefined",
    userFallback: "User ({uid})",
    genericError: "Error",
    roleUpdateError: "Error updating role",
    confirmCancelInvite: "Cancel this invitation?",
    importErrorMsg: "Error during import",
    importRowsWithErrorsSingular:
      "{count} row with errors — check the highlighted cells in red",
    importRowsWithErrorsPlural:
      "{count} rows with errors — check the highlighted cells in red",
    farmsVerifiedMsg: "{count} farms verified — press Import to save",
    farmsImportedMsg: "Import completed: {count} farms added",
    membersVerifiedMsg:
      "{count} users verified ({newCount} new, {existCount} existing) — press Import to save",
    invitedCount: "{count} invited",
    provisionedCount: "{count} users created",
    assignedCount: "{count} assigned",
    newProfilesCount: "{count} new profiles",
    importCompletedMsg: "Import completed: {parts}",
    editFarmData: "Edit farm data",
    cloneFarm: "Clone",
    cloneFarmTitle: "Clone farm",
    cloneFarmChooseSourceTitle: "Clone existing farm",
    cloneFarmChooseSourceLabel: "Farm to clone",
    cloneFarmChooseSourcePlaceholder: "Select farm...",
    cloneFarmSourcePre: "Cloning",
    cloneFarmNewName: "New farm name",
    cloneFarmNewNamePlaceholder: "New farm name",
    cloneFarmSection: "What to clone",
    cloneFarmStructure: "Plots, fields, seasons",
    cloneFarmSoil: "Soil",
    cloneFarmAnimals: "Herd and animals",
    cloneFarmTeam: "Team",
    cloneFarmTraps: "Traps",
    cloneFarmProducts: "Warehouse products",
    cloneFarmEvents: "Animal events",
    cloneFarmOliverecStructure: "Oliverec — structure (plants, geo elements)",
    cloneFarmObservations: "Observations",
    cloneFarmOperations: "Operations",
    cloneFarmOliverecSurveys: "Oliverec — surveys",
    cloneFarmFilterBySeason: "Filter by season (empty = all)",
    cloneFarmOperationsRequiresProducts:
      "Requires 'Warehouse products' enabled",
    cloneFarmEventsRequiresAnimals: "Requires 'Herd and animals' enabled",
    cloneFarmOliverecSurveysRequiresStructure:
      "Requires 'Oliverec — structure' enabled",
    cloneFarmSeasonFilterRequiresStructure:
      "Requires 'Plots, fields, seasons' enabled",
    cloneFarmNameRequired: "Enter the new farm name",
    cloneFarmCloning: "Cloning...",
    cloneFarmSubmit: "Clone farm",
    cloneFarmSuccess: "Farm cloned successfully",
  },

  // ── AppInitializing ──────────────────────────────────────────────────────────
  appInitializing: {
    retry: "Retry",
    loading: "Loading...",
    configTitle: "Loading configuration",
    configMessage: "Connecting to server...",
    databaseTitle: "Initialising database",
    databaseMessage: "Preparing local database...",
    authTitle: "Restoring session",
    authMessage: "Verifying authentication...",
    readyTitle: "Almost ready",
    readyMessage: "Loading completed",
    errorTitle: "Unable to connect",
    errorMessage:
      "The server cannot be reached and no local data is available. Check your connection and retry.",
  },

  // ── AuthComponent ────────────────────────────────────────────────────────────
  authComponent: {
    profileAndPreferences: "Profile and Preferences",
  },

  // ── CreditsView ──────────────────────────────────────────────────────────────
  creditsView: {
    title: "Credits",
    instradareTitle: "Instradare Credits",
    psrTitle: "PSR Tuscany Region Credits",
    psrText:
      'The Poderi web app was developed by <a class="credit-link" href="http://www.aedit.it/" target="_blank" rel="noopener">AEDIT srl</a>, thanks also to funding from the PSR 2014-2020 of the Tuscany Region, Sub-measure 16.2 - Annual Plan 2022, project <a class="credit-link" href="https://progetto.poderi.app/" target="_blank" rel="noopener">Poderi</a>.',
    fairshareTitle: "Fairshare Credits",
    fairshareText:
      'The Poderi web app was developed by <a class="credit-link" href="http://www.aedit.it/" target="_blank" rel="noopener">AEDIT srl</a>, thanks also to funding from the <a class="credit-link" href="https://www.h2020fairshare.eu/" target="_blank" rel="noopener">H2020 FAIRshare</a> project.',
    pisaTitle: "University of Pisa",
    pisaText:
      'The features related to sheep farming were developed in collaboration with the <strong>Centre for Agro-Environmental Research "Enrico Avanzi" (CiRAA)</strong> and with the <strong>Department of Agriculture, Food and Environment</strong>, University of Pisa.',
  },

  // ── ProfileView ──────────────────────────────────────────────────────────────
  profileView: {
    title: "User Profile",
    loading: "Loading...",
    language: "Language",
    personalData: "Personal Data",
    name: "Name",
    email: "Email",
    profile: "Profile",
    phone: "Phone",
    phonePlaceholder: "Enter phone number",
    save: "Save",
    invitationsReceived: "Invitations Received",
    invitation: "Invitation",
    companyTeam: "Farm team",
    organization: "Organisation",
    fromInviter: "from {name}",
    accept: "Accept",
    reject: "Reject",
    acceptInvitation: "Accept Invitation",
    alreadyHasProfile: "You already have a profile in another organisation.",
    newProfileWillBeCreated: "By accepting, a new profile will be created",
    associatedTo: "associated with",
    canChangeProfileName: "You can change the profile name before confirming.",
    aboutToJoin: "You are about to join",
    profileName: "Profile name",
    profileNamePlaceholder: "E.g. John Smith — OrgName",
    visibleToOtherMembers: "Visible to other members of the organisation",
    cancel: "Cancel",
    confirmAndJoin: "Confirm and Join",
    myOrganizations: "My Organisations",
    roleAdmin: "Administrator",
    roleAdvisor: "Advisor",
    roleMember: "Member",
    roleExternal: "External",
    leave: "Leave",
    noOrganizations: "You are not part of any organisation",
    availableOrganizations: "Available Organisations",
    membersCount: "{count} members",
    requestSent: "Request sent",
    requestMembership: "Request membership",
    noPublicOrganizations: "No public organisation available",
    newKey: "New key",
    apiKeyDescription:
      "API keys are secret keys used to access the API programmatically. If another system needs to access Poderi automatically, it can do so with an API key that you then share securely with the other application. If you don't understand this, don't worry, you probably don't need it :)",
    noApiKeys: "No API keys. Create one to access the API programmatically.",
    createdOn: "Created {date}",
    lastUsedOn: "Last used {date}",
    neverUsed: "Never used",
    newApiKey: "New API key",
    newKeyNamePlaceholder: "E.g. Irrigation script",
    newKeyWarning:
      "The key has full access to your account. Keep it safe — it will only be shown once.",
    copyKeyNow: "Copy the key now. It will no longer be visible.",
    close: "Close",
    generate: "Generate",
    genericError: "Error",
    newProfileCreated:
      'Profile created for "{name}". Reload the page or log in again to access it with the new profile.',
    confirmLeaveOrg: 'Do you want to leave the organisation "{name}"?',
    nameRequired: "Name is required",
  },

  adminUsersView: {
    title: "Users",
    loading: "Loading...",
    searchPlaceholder: "Search by name, email, profile, org...",
    onlyActive: "Active only",
    hideInternal: "Hide internal",
    profileCount: "{count} profiles",
    statusActive: "Active",
    statusInactive: "Inactive",
    openDetail: "Open detail",
    breadcrumbHome: "Home",
    breadcrumbAdmin: "Admin",
    colName: "Name",
    colEmail: "Email",
    colProfile: "Profile",
    colStatus: "Status",
    colOrg: "Org",
    colFarms: "Farms",
    colCreatedAt: "Created on",
    colLastLogin: "Last login",
  },

  adminUserDetailView: {
    title: "User Detail",
    loading: "Loading...",
    saveSuccess: "Changes saved.",
    account: "Account",
    name: "Name",
    email: "Email",
    createdAt: "Created on",
    lastLogin: "Last login",
    currentProfile: "Current profile",
    profileName: "Profile name",
    changed: "changed",
    organization: "Organisation",
    noOrg: "— none —",
    farms: "Farms",
    profiles: "Profiles",
    cancel: "Cancel",
    newProfile: "+ New profile",
    noOrgOption: "— no org —",
    createProfile: "Create profile",
    statusActive: "Active",
    statusInactive: "Inactive",
    farmsAbbrev: "{count} farms",
    accountStatus: "Account status",
    statusDisabled: "Disabled",
    disabledWarning: "The user will not be able to access the system.",
    roles: "Roles",
    rolesChangedHint: "Roles changed — save to apply.",
    back: "Back",
    save: "Save",
    breadcrumbHome: "Home",
    breadcrumbAdmin: "Admin",
    breadcrumbUsers: "Users",
    profileNameRequired: "Enter a profile name",
  },

  adminOrgsView: {
    title: "Organisations",
    loading: "Loading...",
    searchPlaceholder: "Search org...",
    orgCount: "{count} orgs",
    newOrg: "+ New org",
    colName: "Name",
    colShortName: "Short name",
    colMembers: "Members",
    colActiveFeatures: "Active features",
    colPublic: "Public",
    editData: "Edit data",
    featureFlag: "Feature flag",
    noOrgsFound: "No orgs found",
    editModalTitle: "Edit: {name}",
    newOrgModalTitle: "New organisation",
    name: "Name",
    fullNamePlaceholder: "Full name",
    shortName: "Short name",
    abbreviationPlaceholder: "Abbreviation",
    description: "Description",
    public: "Public",
    acceptRequests: "Accept requests",
    jsonConfig: "JSON configuration",
    jsonConfigHint: "(key → value)",
    key: "key",
    value: "value",
    remove: "Remove",
    addKey: "+ Add key",
    cancel: "Cancel",
    saving: "Saving...",
    save: "Save",
    create: "Create",
    featureFlagModalTitle: "Feature flag: {name}",
    loadingFeatures: "Loading features...",
    defaultOn: "default ON",
  },

  adminVarietiesView: {
    title: "Varieties",
    loading: "Loading...",
    searchPlaceholder: "Search variety...",
    onlyUnused: "Unused only",
    varietyCount: "{count} varieties",
    colName: "Name",
    colCrop: "Crop",
    colOwner: "Organisation",
    colAccessions: "Accessions",
    shared: "Shared",
    edit: "Edit",
    makeShared: "Make shared",
    delete: "Delete",
    noVarietiesFound: "No varieties found",
    editModalTitle: "Edit: {name}",
    loadingUsage: "Loading usage...",
    usageWarning: "Used by {count} accession(s):",
    name: "Name",
    altName: "Alternative name",
    description: "Description",
    owner: "Organisation",
    cancel: "Cancel",
    saving: "Saving...",
    save: "Save",
    deleteModalTitle: "Delete: {name}",
    deleteConfirmText: "Confirm deletion of this variety? This action cannot be undone.",
  },

  adminWeatherView: {
    title: "Weather Stations",
    refresh: "Refresh",
    statusDisabled: "Disabled",
    statusActive: "Active",
    today: "today",
    recoverButton: "Recover",
    cancelRecoverButton: "Cancel recover",
    modalTitle: "Set historical recover",
    modalHintLine1: "Leave empty to use today's date as the limit.",
    modalHintLine2: "The recover will run at the next cron run",
    labelDateFrom: "Start date (date_from)",
    labelDateTo: "End date (date_to)",
    cancel: "Cancel",
    setRecoverButton: "Set recover",
    breadcrumbHome: "Home",
    colId: "ID",
    colName: "Name",
    colType: "Type",
    colSource: "Source",
    colProvince: "Province",
    colStatus: "Status",
    colVisibility: "Visibility",
    colLastData: "Last data",
    colRecordCount: "Records (1 year)",
    colRecover: "Recover",
  },

  adminWeatherDetailView: {
    defaultTitle: "Station",
    stationsList: "Stations list",
    loading: "Loading...",
    baseDataHeader: "Basic data",
    stationNameLabel: "Station name",
    visibilityLabel: "Visibility",
    visibilityFarm: "Farm",
    visibilityOrg: "Org",
    visibilityPublic: "Public",
    visibilityPrivate: "Private",
    statusLabel: "Status",
    statusDisabled: "Disabled",
    statusActive: "Active",
    sourceLabel: "Source:",
    codeLabel: "Code:",
    provinceLabel: "Province:",
    saveButton: "Save",
    recoverHeader: "Historical recover",
    recoverFromLabel: "From",
    recoverToLabel: "to",
    today: "today",
    removeButton: "Remove",
    recoverDateFromLabel: "From",
    recoverDateToLabel: "To (empty = today)",
    setRecoverButton: "Set recover",
    recoverHint: "The recover runs at the next cron run",
    sensorUnitsHeader: "Sensor unit configuration",
    dailyDataHeader: "Daily data per year",
    noDailyData: "No daily data.",
    hourlyDataHeader: "Hourly data per year",
    noHourlyData: "No hourly data.",
    colYear: "Year",
    colRecord: "Records",
    colFrom: "From",
    colTo: "To",
  },

  adminAepestView: {
    title: "Plant Protection Products",
    statusCardTitle: "Table status",
    manageCropsLink: "Manage crops",
    lastUpdate: "Last update: {date}",
    loading: "Loading...",
    statTotal: "Total",
    statAttivi: "Active",
    statConPdf: "{count} with PDF",
    statAutorizzati: "Authorised",
    statRiRegistrati: "Re-registered / Renewed",
    statConDosiEstratte: "With extracted doses",
    statTraGliAttivi: "among the active ones",
    statRevocati: "Revoked",
    statScadutiSospesi: "Expired / Suspended",
    productsCardTitle: "Products and PDFs",
    searchPlaceholder: "Search product, reg. no., company...",
    onlyActive: "Active only",
    onlyExtracted: "Extracted only",
    withoutPdf: "Without PDF",
    searchButton: "Search",
    colNumReg: "Reg. No.",
    colProdotto: "Product",
    colImpresa: "Company",
    colStato: "Status",
    colPdf: "PDF",
    colUltimaEtichetta: "Last label",
    colEstratto: "Extracted",
    pdfCount: "{count} PDF",
    dosesBadge: "✓ doses",
    totalProducts: "{total} products",
    breadcrumbHome: "Home",
    breadcrumbAdmin: "Admin",
    breadcrumbFitosanitari: "Plant Protection",
  },

  adminAepestProductView: {
    titleFallback: "Plant protection product",
    loading: "Loading...",
    listLink: "list",
    labelNumReg: "Reg. No.",
    labelImpresa: "Company:",
    labelFormulazione: "Formulation:",
    labelSostanzeAttive: "Active substances:",
    labelDataReg: "Reg. date:",
    labelScadenza: "Expiry:",
    labelEtichetta: "Label",
    pdfPanelTitle: "PDF label",
    openInNewTab: "Open in new tab ↗",
    dosesPanelTitle: "Extracted doses",
    extractedOn: "extracted {date}",
    notProcessed: "not processed",
    jsonButton: "{ } JSON",
    noExtractedData: "No data extracted for this label.",
    crops: "{count} crops",
    apiRestrictionsWarn: "⚠ pre-harvest restrictions",
    colCrop: "Crop",
    colAdversity: "Pest/disease",
    colDose: "Dose",
    colWaterVol: "Water vol.",
    colNumTreatments: "No. treatments",
    colInterval: "Interval",
    colPreHarvest: "Pre-harvest",
    breadcrumbFitosanitari: "Plant Protection",
  },

  adminSpatialModelView: {
    title: "Spatial Model",
    newRun: "New run",
    availableModels: "Available models",
    addModel: "Add model",
    configuredRuns: "Configured runs",
    modalEditRunTitle: "Edit run",
    modalNewRunTitle: "New spatial model run",
    modelLabel: "Model *",
    selectModelPlaceholder: "— select model —",
    yearLabel: "Year *",
    dateFromLabel: "Start date",
    dateToLabel: "End date",
    areaLabel: "Geographic area *",
    drawingHint: "Click and drag…",
    drawArea: "Draw area",
    dirNorth: "N",
    dirSouth: "S",
    dirEast: "E",
    dirWest: "W",
    clear: "Clear",
    modelVarsLabel: "Model variables (JSON)",
    modelVarsHint:
      "JSON with fixed model variables. The worker adds id_station, date_from, date_to.",
    runningWarning:
      "This run is currently running (or got stuck). Saving will reset it to pending and it can be run again.",
    cancel: "Cancel",
    save: "Save",
    createRun: "Create run",
    modalEditModelTitle: "Edit model",
    modalNewModelTitle: "New model",
    modelNameLabel: "Model name *",
    modelNamePlaceholder: "e.g. dss_olivefly_complete",
    labelLabel: "Label",
    labelPlaceholder: "e.g. Olive fly",
    defaultJsonLabel: "Default JSON (fixed model variables)",
    outputVarsLabel: "Output variables",
    colKey: "Key",
    colLabelShort: "Label",
    colType: "Type",
    primaryTooltip: "Primary variable for map colour",
    primaryText: "Primary",
    keyPlaceholder: "e.g. final_value.alert_level",
    typeNumeric: "numeric (0-1)",
    typeCategorical: "categorical",
    addOutputVar: "Add variable",
    colModelName: "Model name",
    colModel: "Model",
    colYear: "Year",
    colFrom: "From",
    colTo: "To",
    colStatus: "Status",
    colProgress: "Progress",
    colCreated: "Created",
    invalidJson: "Invalid JSON",
  },

  farmsView: {
    title: "Farm Centers Table",
    id: "ID",
    name: "Name",
    address: "Address",
    lat: "Lat",
    lng: "Lng",
    actions: "Actions",
    edit: "Edit",
    loading: "Loading...",
    noFarmsFound: "No farms found.",
    editFarmTitle: "Edit farm",
    nameLabel: "Name:",
    save: "Save",
    cancel: "Cancel",
    updateError: "Update error",
    loadError: "Loading error.",
  },

  geoElementDetailView: {
    companies: "Farms",
    company: "Farm",
    geoElement: "Geographic element",
  },

  oliverecHomeView: {
    title: "Plantrec — Plant surveys",
    subtitle: "Select the plot and the survey form",
    loading: "Loading...",
    noSchemas: "No survey form configured for this organisation.",
    noPlots: "No plot with loaded accessions available for this farm.",
    schemaLabel: "Survey form",
    schemaPlaceholder: "Select form...",
    plotLabel: "Plot",
    plotPlaceholder: "Select plot...",
    start: "Start",
    desktopHint: "Working from a desktop?",
    excelLink: "Enter data via Excel table →",
    plantCount: "{count} plants",
  },

  oliverecSurveyView: {
    defaultTitle: "Plant survey",
    afterSaveTitle: "After saving",
    navForward: "▶ Forward",
    navStay: "↺ Stay",
    navBack: "◀ Back",
    navSnake: "↔ Snake",
    navConfigTitle: "Movement configuration",
    navAxisLabel: "What changes on each plant",
    navAxisPlant: "The plant (column)",
    navAxisRow: "The row",
    navAxisRowShort: "row",
    navConfigClose: "Close",
    saveWhileUploadingTitle: "Photo still uploading: saving now will still associate the image with this plant once the upload completes",
    saving: "Saving...",
    save: "Save",
    breadcrumbHome: "Plantrec",
    breadcrumbSurvey: "Survey",
  },

  spadeTestView: {
    cancel: "Cancel",
    next: "Next →",
    start: "Start →",
    back: "Back",
    saveAndExit: "Save and exit",
    finish: "Finish",
    title: "Spade Test",
    selectFieldSubtitle: "Select the field where to run the test",
    noFieldsAvailable: "No field available for the current season.",
    goBack: "Go back",
    suggestedSampleCode: "Suggested sample code:",
    loading: "Loading…",
    defaultFarmName: "Farm",
    breadcrumbHome: "Home",
    breadcrumbFarms: "Farms",
    breadcrumbMonitoring: "Monitoring",
  },

  accessionsView: {
    title: "Accessions Management",
    accessions: "Accessions",
    varieties: "Varieties",
    totalPlants: "Total plants",
    withAccession: "With accession",
    plots: "Plots",
    statusEmpty: "No plants",
    statusNone: "Without accessions",
    statusComplete: "With accessions",
    tabAccessions: "Accessions",
    tabPlots: "Plots",
    tabVarieties: "Varieties",
    colAccession: "Accession",
    colVariety: "Variety",
    colSource: "Source",
    colPlants: "Plants",
    colFarm: "Farm",
    colPlot: "Plot",
    colPlots: "Plots",
    colStatus: "Status",
    colAccessionsCount: "Accessions",
    colVarietyCount: "Varieties",
    colCrop: "Crop",
    endangered: "Endangered variety",
    colEndangered: "Extinction risk",
    endangeredYes: "At risk",
    onlyEndangered: "Endangered only ({count})",
    showAll: "Show all",
  },

  accessionElabView: {
    title: "Survey Data Analysis",
    home: "Home",
    accessions: "Accessions",
    dataElaboration: "Data Analysis",
  },

  accessionElab: {
    schema: "Schema",
    ordinateVariable: "Variable (Y axis)",
    groupBy: "Group by (X axis)",
    series: "Series (colors)",
    loadingData: "Loading data...",
    loadError: "Error loading data",
    noDataForSchema: "No data found for this schema.",
    filters: "Filters",
    filtersActive: "{count} active",
    filtersNone: "none",
    farmCenter: "Farm",
    plot: "Plot",
    all: "All",
    allFem: "All",
    year: "Year",
    variety: "Variety",
    selectVariablePlaceholder: "— Select variable —",
    tabChart: "Chart",
    tabAggregatedData: "Aggregated Data",
    tabRawData: "Raw Data",
    tabImages: "Images",
    selectVariableHint: "Select a variable to display the chart.",
    rows: "rows",
    downloadCsv: "Download CSV",
    imagesCount: "{visible} / {total} images",
    noImagesForFilters: "No images in the filtered data.",
    removeFromAiTraining: "Remove from AI training",
    addToAiTraining: "Add to AI training",
    loadMore: "Load more ({count} remaining)",
    value: "Value",
    count: "N",
    percent: "%",
    mean: "Mean",
    min: "Min",
    q1: "Q1",
    median: "Median",
    q3: "Q3",
    max: "Max",
    date: "Date",
    accession: "Accession",
    frequencyPercent: "% frequency",
    tooltipMin: "Min: {value}",
    tooltipQ1: "Q1: {value}",
    tooltipMedian: "Median: {value}",
    tooltipQ3: "Q3: {value}",
    tooltipMax: "Max: {value}",
    tooltipN: "N: {value}",
  },

  plantSurveyMobile: {
    loading: "Loading...",
    row: "Row",
    plant: "Plant",
    qr: "QR",
    map: "Map",
    plantWithoutAccession: "Plant without accession",
    qrNotAcquired: "QR not acquired",
    surveyPresent: "Survey present",
    plantNotFound: "Plant not found ({row}/{col})",
    surveyDate: "Survey date",
    editingExistingSurvey: "You are editing an existing survey",
    acquireFromQr: "Scan from QR code",
    deleteSurvey: "Delete survey",
    selectPositionHint: "Select a position with a plant to enter data.",
    confirmDeleteSurvey: "Are you sure you want to delete this survey?",
    cancel: "Cancel",
    delete: "Delete",
    plantMap: "Plant map",
    current: "Current",
    selected: "Selected",
    surveyOk: "Survey ok",
    todo: "To do",
    rowPlantPos: "Row {row} · Plant {col}",
    noSurvey: "No survey",
    goToPlant: "Go to this plant",
    clickPlantForDetails: "Click on a plant for details",
  },
  modelWidget: {
    calculating: "calculating…",
    calculatingInProgress: "Calculating…",
    detailLabel: "Details →",
    modelRunning: "Model running…",
    reportNotAvailable: "Report not available.",
    chart: "Chart",
    detailedData: "Detailed data",
    calculationError: "Error calculating the model",
    modelNotStarted: "Model not yet started",
  },
  modelsCommon: {
    errorFieldNotFound: "Field not found",
    errorFarmNotLoaded: "Farm not loaded",
    errorModel: "Model error",
    errorNetwork: "Network error",
    errorCropNotDefined:
      "Warning. The crop for this field has not been defined",
    csvInvalidFile: "Warning! The file is not valid",
    modelStartsToday:
      ". The model's start date is today. The first model run will happen tomorrow",
    modelStartsFuture: ". The model has a future start date!",
    resultAvailable: "Result available",
    irrigate: "Irrigate {value} mm",
    deficit: "Deficit: {value} mm",
    nutriBalance: "N:{n} · P:{p} · K:{k} kg/ha",
    phenologyFallback: "Phenology",
    bioclimFallback: "Bioclimatic indices",
    bioclimIndices: "Huglin: {huglin} · Winkler: {winkler}",
    seasonEnded: "Season ended",
    riskLevel: { high: "High", medium: "Moderate", low: "Low", info: "None" },
    oliveFly: {
      modelNotStarted: {
        title: "The model starts on June 4th",
        text: "The model will be active from June 4th",
      },
      lowP: { title: "Low risk", text: "Low risk of oviposition onset" },
      mediumP: { title: "Attention", text: "Increasing risk of oviposition" },
      highPLowMortality: {
        title: "Oviposition in progress",
        text: "High risk of oviposition - temperatures favor development",
      },
      highPHighMortality: {
        title: "Oviposition contained",
        text: "High risk of oviposition, but high temperatures may limit development",
      },
      modelEnd: {
        title: "Season ended",
        text: "The model's validity period has ended",
      },
      riskPercent: "Risk: {value}%",
      default: "Olive fly",
    },
    lobesia: {
      stages: {
        c0: {
          label: "Overwintering pupae",
          message: "No risk. Overwintering.",
        },
        a1: {
          label: "Adults 1st gen.",
          message:
            "Low risk. Gather information and decide monitoring and control strategies for the next stages.",
        },
        u1: {
          label: "Eggs 1st gen.",
          message:
            "Low risk. Gather information and decide monitoring and control strategies for the next stages.",
        },
        l1: {
          label: "Larvae 1st gen.",
          message:
            "Low risk. Gather information and decide monitoring and control strategies for the next stages.",
        },
        c1: {
          label: "Pupae 1st gen.",
          message: "Medium risk. Place traps to monitor adults.",
        },
        a2: {
          label: "Adults 2nd gen.",
          message:
            "High risk. Oviposition will start soon. Field monitoring, assess control strategy.",
        },
        u2: {
          label: "Eggs 2nd gen.",
          message:
            "High risk. Oviposition in progress. Monitor clusters, assess control strategy.",
        },
        l2: {
          label: "Larvae 2nd gen.",
          message:
            "Medium risk. Larval development in progress. Monitor clusters, assess control strategy.",
        },
        c2: {
          label: "Pupae 2nd gen.",
          message: "Medium risk. Pupal stage. Field monitoring.",
        },
        a3: {
          label: "Adults 3rd gen.",
          message:
            "High risk. Oviposition will start soon. Field monitoring, assess control strategy.",
        },
        u3: {
          label: "Eggs 3rd gen.",
          message:
            "High risk. Oviposition in progress. Field monitoring, assess control strategy.",
        },
        l3: {
          label: "Larvae 3rd gen.",
          message:
            "Medium risk. Larval development in progress. Field monitoring, assess control strategy.",
        },
        c3: {
          label: "Pupae 3rd gen.",
          message: "Low risk. Pupal stage. Field monitoring.",
        },
        endCycle: { label: "End of cycle", message: "No risk." },
      },
      generation: "Grapevine moth: gen. {generation}",
      default: "Grapevine moth",
    },
    powdery: {
      default: "Powdery mildew",
      riskNotSprouted: "Vine not sprouted",
      riskHigh: "High risk",
      riskMedium: "Medium risk",
      riskLow: "Low risk",
      riskWithValue: "{label} ({value})",
    },
    plasmo: {
      infections: "Downy mildew: {primary} primary inf., {secondary} secondary",
      noInfection: "Downy mildew: no infection",
    },
    botrytis: {
      combined:
        "Botrytis – Climatic risk: {climat} · Phenological risk: {pheno}",
      single: "Botrytis – climatic infection risk: {climat}",
      gonzalez: "Botrytis González – risk: {label}",
      phaseSuffix: " · phase: {phase}",
    },
    corn: {
      default: "Corn",
      overwintering: "Overwintering",
      youngLarvae: "Young larvae in soil",
      larvaeInSoil: "Larvae in soil",
      soilCrysalid: "Pupae in soil",
      flightStart: "Adult flight start",
      flightPeak: "Flight peak",
      flightDecrease: "Flight decreasing",
      flightEnded: "Flight ended",
      overwinteringO: "Overwintering",
      adult0: "Adults gen. 0",
      egg1: "Eggs gen. 1",
      egg2: "Eggs gen. 2",
      egg3: "Eggs gen. 3",
      l11: "L1 larvae gen. 1",
      l21: "L2 larvae gen. 1",
      l31: "L3 larvae gen. 1",
      l41: "L4 larvae gen. 1",
      l51: "L5 larvae gen. 1",
      cr1: "Pupae gen. 1",
      ad1: "Adults gen. 1",
      lx3: "Larvae gen. 3",
      end3: "Season end",
      adults: "Adults",
      adultPreovi: "Pre-oviposition",
      adultOvi: "Oviposition",
      egg: "Eggs",
      larvae: "Larvae",
      pupae: "Pupae",
      adultEmergence2: "Adults, 2nd generation",
    },
    diabro: {
      labels: {
        overwintering: "Eggs",
        youngLarvae: "First-instar larvae",
        larvaeInSoil: "Larvae in soil",
        soilCrysalid: "Pupae in soil",
        flightStart: "Flight start",
        flightPeak: "Flight peak",
        flightDecrease: "Flight decreasing",
        flightEnded: "Flight ended",
      },
      messages: {
        overwintering: "Not the time to treat",
        youngLarvae: "Not the time to treat",
        larvaeInSoil: "Not the time to treat",
        soilCrysalid: "Adult emergence will start soon",
        flightStart: "Prepare for treatment",
        flightPeak: "Consider treating, if not already done",
        flightDecrease: "Consider treating, if not already done",
        flightEnded: "Not the time to treat",
      },
    },
    ostrinia: {
      labels: {
        notStarted: "Model not started yet",
        overwintering: "Overwintering forms",
        adult0: "Adults",
        egg1: "Eggs",
        l11: "First-instar larvae, 1st generation",
        l21: "Second-instar larvae, 1st generation",
        l31: "Third-instar larvae, 1st generation",
        l41: "Fourth-instar larvae, 1st generation",
        l51: "Fifth-instar larvae, 1st generation",
        cr1: "Pupae, 1st generation",
        ad1: "Adults, 1st generation",
        egg2: "Eggs, 2nd generation",
        l12: "First-instar larvae, 2nd generation",
        l22: "Second-instar larvae, 2nd generation",
        l32: "Third-instar larvae, 2nd generation",
        l42: "Fourth-instar larvae, 2nd generation",
        l52: "Fifth-instar larvae, 2nd generation",
        cr2: "Pupae, 2nd generation",
        ad2: "Adults, 2nd generation",
        egg3: "Eggs, 3rd generation",
        lx3: "Larvae, 3rd generation",
        end3: "Cycle ended",
      },
      messages: {
        notStarted: "",
        overwintering: "Not the time to treat",
        adult0: "Oviposition will start soon, prepare for treatment",
        egg1: "Consider treating, if not already done",
        l11: "Larval development has started, consider treating if not already done",
        l21: "Not the time to treat",
        l31: "Not the time to treat",
        l41: "Not the time to treat",
        l51: "Not the time to treat",
        cr1: "Not the time to treat",
        ad1: "Oviposition will start soon, prepare for treatment",
        egg2: "Consider treating, if not already done",
        l12: "Larval development has started, consider treating if not already done",
        l22: "Not the time to treat",
        l32: "Not the time to treat",
        l42: "Not the time to treat",
        l52: "Not the time to treat",
        cr2: "Not the time to treat",
        ad2: "Oviposition will start soon, prepare for treatment",
        egg3: "Consider treating, if not already done",
        lx3: "Not the time to treat",
        end3: "Not the time to treat",
      },
    },
    heli: {
      labels: {
        adults: "Adults",
        adultPreovi: "Non-ovipositing adults",
        adultOvi: "Ovipositing adults",
        egg: "Eggs",
        larvae: "Larvae",
        pupae: "Pupae",
        adultEmergence2: "Adult emergence, 2nd generation",
        flightEnded: "Cycle ended",
      },
      messages: {
        adults: "Adults are emerging",
        adultPreovi: "Oviposition will start soon",
        adultOvi:
          "Oviposition in progress, consider treating if not already done",
        egg: "Consider treating, if not already done",
        larvae: "Not the time to treat",
        pupae: "Not the time to treat",
        adultEmergence2: "Oviposition will start soon",
        flightEnded: "The seasonal cycle has ended",
      },
    },
    diseaseHelp: {
      tignoletta: `<p><strong>European grapevine moth</strong> (<em>Lobesia botrana</em>)</p><p>The model simulates the development of the three annual generations of the grapevine moth based on accumulated temperatures (degree-days). It indicates the timing of adult flights and the percentage of larvae present.</p><ul><li><strong>Low risk:</strong> contained populations or inactive generation</li><li><strong>Medium risk:</strong> flight in progress, monitor traps</li><li><strong>High risk:</strong> flight peak, consider treatment</li></ul>`,
      peronospora: `<p><strong>Grapevine downy mildew</strong> (<em>Plasmopara viticola</em>)</p><p>Three models with different approaches are available. The choice depends on the quality of the available weather data and the level of detail required.</p><p><strong>3-10 Goidanich</strong> — cautious reference model</p><p>Based on the 3-10 rule and Goidanich's infection calculation. It is the model to prefer when unsure about the quality or representativeness of the weather data relative to the farm. Being cautious, it tends to overestimate treatment needs compared to more advanced models: better one extra treatment than one too few under uncertainty.</p><p><strong>Downy mildew Plus - epidemiological model - Mechanistic</strong> — advanced model for reliable, hourly weather data</p><p>To be used when the weather data is very close to the farm and hourly rainfall data is available. The model simulates zoospore development in the soil day by day and estimates whether infectious rains actually have the conditions to cause primary infections. It provides a more precise estimate than the mechanistic model, but requires quality weather data to avoid losing reliability.</p><p><strong>Machine Learning</strong> — experimental model</p><p>Machine learning model built on historical data from the monitoring network. Returns the probability of symptoms appearing in the following week. The model is still being tested and validated: results should be interpreted as a trend indicator, not a certain forecast. It is recommended to always use it alongside the other models before making treatment decisions.</p>`,
      oidio: `<p><strong>Grapevine powdery mildew</strong> (<em>Erysiphe necator</em>)</p><p>Two models are available:</p><ul><li><strong>Powdery mildew model:</strong> follows the fungus biological cycle based on temperature and humidity</li><li><strong>Machine Learning</strong> — estimates the probability of symptoms in the next 7 days via machine learning</li></ul>`,
      botrite: `<p><strong>Grapevine botrytis</strong> (<em>Botrytis cinerea</em>)</p><p>Two models are available:</p><ul><li><strong>Botrytis model:</strong> calculates leaf wetness hours favorable to infection</li><li><strong>Machine Learning</strong> — estimates the probability of symptoms in the next 7 days via machine learning</li></ul>`,
    },
  },
  phenoRender: {
    alertLabel: "Prevailing stage",
    cumulativeDegreeDays: "Cumulative degree days:",
    genericLabel: "Phenology",
    end: "End",
    noResults: "No results available.",
    table: {
      date: "Date",
      stageCurrent: "Current stage",
      percPhase: "Stage percentage (%)",
      report: "Report",
    },
    chart: {
      dayDegree: "Degree days",
      confirmed: "Confirmed",
      anticipated: "Early",
      delayed: "Delayed",
      degreeDaysUnit: "GDD",
    },
    correction: {
      question: "Is the estimated stage correct?",
      saving: "Saving…",
      yes: "✓ Yes",
      no: "✗ No, correct it",
      noBbchTitle: "No BBCH stage to confirm",
      confirmedMsg: "✓ Stage confirmed and recorded",
      editQuestion: "Select the stage observed in the field:",
      choosePlaceholder: "— choose —",
      cancel: "Cancel",
      save: "Save observation",
      saved: "✓ Observation saved — the model will be recalculated",
      errorDefault: "Error while saving",
    },
    phaseSummary: {
      title: "Phenological stage summary",
      bbch: "BBCH",
      stage: "Stage",
      start: "Start",
      end: "End",
      observations: "Observations",
    },
    obs: {
      editTitle: "Edit",
      deleteTitle: "Delete",
      addTitle: "Add observation",
      errorDefault: "Error",
    },
    badge: {
      corrected: "⚡ Corrected (was {value})",
      confirmed: "✓ Confirmed",
    },
  },
  phenoHeatmap: {
    title: "Theoretical generations",
    noData: "No phenological data available.",
    stages: {
      adult: "Adults",
      pupa: "Pupae",
      larva: "Larvae",
      eggs: "Eggs",
    },
  },
  grapeBioclimRender: {
    kpi: {
      huglin: "Huglin index",
      winkler: "Winkler index",
      gddAllen: "Cum. GDD Allen",
    },
    table: {
      datetime: "Date",
      tavg: "Avg temp. (°C)",
      tmin: "Min temp. (°C)",
      tmax: "Max temp. (°C)",
      gdd: "Cum. GDD",
      winkler: "Cum. Winkler",
      huglin: "Cum. Huglin",
      daysDiffHuglin: "Δ days Huglin vs prev. year",
      daysDiffWinkler: "Δ days Winkler vs prev. year",
    },
    huglinClasses: {
      veryCold: "Very cold",
      cold: "Cold",
      temperate: "Temperate",
      warm: "Warm",
      veryWarm: "Very warm",
    },
    winklerClasses: {
      zoneI: "Zone I",
      zoneII: "Zone II",
      zoneIII: "Zone III",
      zoneIV: "Zone IV",
      zoneV: "Zone V",
    },
    legend: { huglinTitle: "Huglin classes:" },
    chart: {
      cumulativeIndicesTitle: "Cumulative bioclimatic indices",
      huglinDataset: "Huglin",
      winklerDataset: "Winkler",
      diffTitle: "Lead/lag versus previous year (days)",
      diffYAxis: "Days (neg.=early, pos.=late)",
      diffHuglinDataset: "Δ days Huglin vs prev. year",
      diffWinklerDataset: "Δ days Winkler vs prev. year",
    },
    diff: {
      inLine: "In line with prev. year",
      anticipo: "{value} days early",
      ritardo: "{value} days late",
    },
  },
  pestLobesiRender: {
    table: {
      date: "Date",
      status: "Prevailing stage",
      eggs: "Eggs",
      larvae: "Larvae",
      pupae: "Pupae",
      adults: "Adults",
    },
    title: { default: "Grape moth", seasonEnded: "Season ended" },
    chart: {
      title: "European grapevine moth development over time",
      eggs: "Eggs",
      larvae: "Larvae",
      pupae: "Pupae",
      adults: "Adults",
    },
  },
  pestOliveFlyRender: {
    modelNotStartedWarning: "Warning! The model has not started yet.",
    noData: "Data not available.",
    ovi: {
      setDate: "Set oviposition start date",
      editDate: "Edit oviposition start date",
      editButton: "Edit",
      removeManualDate: "Remove manual date",
      dateSet: "Date set:",
      restoreAutoDate: "Restore automatic date",
      insertDateIfDetected: "Enter oviposition date if already detected",
      startLabel: "Oviposition start:",
      notStartedYet: "(not started yet)",
      modelForecast: "Model forecast:",
    },
    badge: { manual: "manual", auto: "automatic" },
    actions: { save: "Save", cancel: "Cancel" },
    error: { saveFailed: "Error while saving" },
    chart: {
      dailyMortality: "Daily mortality",
      cumMortality7d: "7-day cumulative mortality",
      riskInceptionTitle: "Oviposition onset risk",
    },
    table: {
      date: "Date",
      status: "Status",
      mortality: "Daily mortality",
      mortalityCum7d: "7-day cum. mortality",
      riskOviposition: "Oviposition risk",
      phenoPhase: "Fly phenological stage",
    },
  },
  pestBotrytisRender: {
    kpi: {
      climaticRisk: "Climatic risk",
      infectionIndex: "Infection index",
      phenoRisk: "Phenological risk",
      combinedRisk: "Combined risk",
      berryStage: "Berry stage",
    },
    table: {
      date: "Date",
      alertLevelClimat: "Climate risk",
      alertLevelPheno: "Phenological risk",
      combinedRisk: "Combined risk",
    },
    risk: { high: "High", medium: "Moderate", low: "Low", info: "No risk" },
    chart: {
      title: "Botrytis infection index (climatic)",
      yAxisTitle: "Infection index",
      lowBand: "Low (0–0.5)",
      moderateBand: "Moderate (0.5–1)",
      highBand: "High (>1)",
      infectionIndex: "Infection index",
    },
  },
  pestBotrytisGonzalezRender: {
    kpi: {
      risk: "Risk",
      riskIndex: "Risk index",
      phase: "Phase",
      sev1: "SEV1 (flowering)",
      sev2: "SEV2 (berries)",
      sev3: "SEV3 (secondary)",
    },
    table: { date: "Date", risk: "Risk", phase: "Phase", sev: "SEV 1/2/3" },
    risk: { high: "High", medium: "Moderate", low: "Low", info: "No risk" },
    phase: { flowering: "Flowering", ripening: "Ripening", neutral: "Neutral" },
    chart: {
      title: "Botrytis risk – González model (daily)",
      yAxisTitle: "Risk index",
      lowBand: "Low (<0.2)",
      moderateBand: "Moderate (<0.5)",
      highBand: "High (>0.5)",
      sev1: "SEV1 (flowering)",
      sev2: "SEV2 (berries)",
      riskGonzalez: "González risk",
    },
  },
  pestCornRender: {
    kpi: { gdd: "Cumulative GDD", currentPhase: "Current phase" },
    defaultTitle: "Corn - Defense",
    table: {
      date: "Date",
      phase: "Phase",
      soilLarvae: "Soil larvae (%)",
      adultsPercent: "Adults (%)",
      eggs: "Eggs",
      larvae: "Larvae",
      adults: "Adults",
      pupae: "Pupae",
      ovideposition: "Oviposition (%)",
    },
    chart: {
      soilLarvae: "Larvae in soil (%)",
      adultsFlight: "Adults - flight (%)",
      eggs: "Eggs",
      larvae: "Larvae",
      pupae: "Pupae",
      adults: "Adults",
      eggsPercent: "Eggs (%)",
      larvaePercent: "Larvae (%)",
      pupaePercent: "Pupae (%)",
      ovideposition: "Oviposition (%)",
      adultsGen2: "Adults 2nd gen. (%)",
      titleDiabro: "Diabrotica virgifera — development over time",
      titleOstrinia: "Ostrinia nubilalis — development over time",
      titleHeli: "Helicoverpa armigera — development over time",
      titleDefault: "Development over time",
    },
  },
  pestGrapeMlRender: {
    modelEnded: "The crop production cycle has ended.",
    notStarted:
      "The model has not started yet (insufficient data or season not started).",
    table: {
      date: "Date",
      pInf: "Probability of symptoms within 7 days",
    },
    kpi: {
      lastCalcDate: "Last calculation date",
    },
    title: {
      notStarted: "Model not yet started",
      withValue: "Probability of symptoms within 7 days: {value}%",
    },
    risk: { high: "High risk", medium: "Medium risk", low: "Low risk" },
    status: { absent: "Absent" },
    chart: { title: "Symptom probability over the next 7 days (%)" },
  },
  pestGrapeOidioRender: {
    modelEnded: "The crop production cycle has ended.",
    kpi: { currentRisk: "Current risk" },
    warning: {
      title: "Important note:",
      text: "The current model provides purely climate-based risk. This data must be combined with actual field presence of powdery mildew, previous years' pressure, and phenological phase.",
    },
    table: {
      date: "Date",
      pheno: "Phenology",
      riskIndex: "Risk index",
      riskClass: "Risk class",
    },
    risk: {
      ended: "Model ended",
      notSprouted: "Vine not sprouted",
      low: "Low risk",
      medium: "Medium risk",
      high: "High risk",
    },
    advice: {
      low: "If treating with sulfur, use a 14-21 day frequency",
      medium: "If treating with sulfur, use a 10-17 day frequency",
      high: "If treating with sulfur, use a 7 day frequency",
    },
    chart: { title: "Powdery mildew risk index over time" },
  },
  pestGrapePlasmoRender: {
    notStarted: {
      title: "Model not yet started",
      estimatedStart: "Crop phenology estimates the start on",
      startDateUnavailable:
        "The start date is not yet available (BBCH 15 phenological phase not reached).",
    },
    modelEnded: {
      title: "Model ended",
      sub: "The monitoring season has ended (late September).",
    },
    kpi: {
      totalPrimary: "Total primary infections",
      totalSecondary: "Total secondary infections",
      status: "Status",
      primaryInfections: "Primary infections",
      secondaryInfections: "Secondary infections",
    },
    status: { pending: "Not started", ended: "Ended" },
    statusLabels: {
      noActiveInfection: "No active infection",
      infectionCytoSystemic: "Infection — Cytotropic or Systemic",
      infectionSystemic: "Infection — Systemic",
      waitToTreat: "Wait before treating",
      infectionContact: "Infection — Contact products",
      unknown: "Unknown status",
    },
    table: {
      date: "Date",
      pheno: "Phenology",
      status: "Status",
      primary: "Primary inf.",
      secondary: "Secondary inf.",
    },
    chart: {
      primaryInfections: "Primary infections",
      secondaryInfections: "Secondary infections",
      countTitle: "Downy mildew infections over time",
      germinationTitle: "Germination progress per infection",
      germinationYAxis: "Germination (%)",
    },
  },
  pestPlasmoPlusRender: {
    table: {
      familyTableLabel: "Oospore families",
      family: "Family",
      lastStatus: "Last Status",
      germinationPercent: "Germination %",
    },
    infoBox: {
      notReceptive:
        "The vegetation is not yet receptive (waiting for BBCH 15).",
      receptiveSince: "Receptive since",
      budsOpenSince: "buds open (BBCH 8) since",
      pisSeason: "PIS Season",
      oosporesActiveSince: "oospores active since",
      until: "to",
      noNewFamilyAfter: "after this date no new family is generated",
      lastEventOn: "last event on",
    },
    kpi: {
      activeFamilies: "Active families",
      maxPhaseReached: "Max phase reached",
      maxGermination: "Max germination",
      currentPhenology: "Current phenology",
    },
    dailyData: {
      title: "Daily data",
    },
    dailyTable: {
      date: "Date",
      maturation: "Maturation",
      oospores: "oospores",
      maxGer: "Max GER",
      status: "Status",
      start310: "Start 310",
      startPlus: "Start Plus",
    },
    badge: {
      sporulata: "Sporulated",
      infetta: "Infected",
      rule310Tooltip: "310 conditions: T>12°C, 48h rain ≥10mm, BBCH≥15",
    },
    tablePre: {
      text: "At every soil wetting event, if the oospores are not dormant, the model creates a new oospore family. For each family, a sequence of events follows (germination, zoospore release, infection, sporulation, etc.) which are monitored and shown in this table.",
    },
    field: {
      ended: "ended",
      active: "active",
    },
    modal: {
      dayDetailTitle: "Detail {date}",
      noHourlyData: "Hourly data not available.",
      hourlyMeteoHeader:
        "Hourly weather · GEO = live sporangia · REL = zoospore release · SUZ = live zoospores",
      hour: "Hour",
      sporangiTitle: "Live sporangia",
      releaseTitle: "Zoospore release",
      zoosporesTitle: "Live zoospores",
      event: "Event",
      familyHistoryTitle: "Family {fam} — Phase history",
    },
    statusLabels: {
      oosporeGermination: "Oospore germination",
      sporangiumSurvival: "Sporangium survival",
      zoosporeRelease: "Zoospore release",
      zoosporeDispersion: "Zoospore dispersion",
      plantNotReceptive: "Plant not receptive",
      leafInfection: "Leaf infection",
      sporulation: "Sporulation",
      sporulationEnd: "Sporulation end",
      unknownStatus: "Status {id}",
    },
    historyLabels: {
      oosporeGermination: "Oospore germination",
      sporangium: "Sporangium",
      zoosporesReleased: "Zoospores released",
      zoosporeDispersion: "Zoospore dispersion",
      infectionNotReceptive: "Infection (plant not receptive)",
      leafInfection: "Leaf infection",
      sporulation: "Sporulation",
      sporulationEnd: "Sporulation end",
    },
    mainMessage: {
      primaryInfectionsEnded: "H. This year's primary infections have ended.",
      oosporesDormant: "The oospores are dormant (HT {ht} / threshold 1.3).",
      noFamiliesDormancy:
        "There are no oospore families. Dormancy at {percent}%.",
      oosporesInDevelopment:
        "A. Oospores developing (max germination {percent}%).",
      oosporesNearGermination:
        "A. Oospores close to germination (max {percent}%).",
      sporangiaProduced: "B. The oospores have produced sporangia.",
      zoosporesReleased: "C. The zoospores have been released.",
      zoosporesDispersed:
        "D. The zoospores have dispersed and reached the plant.",
      potentialInfectionNotReceptive:
        "D. Potential infection conditions but plant not receptive.",
      leafInfectionOccurred:
        "E. Leaf infection has occurred — incubation period in progress.",
      sporulationOccurred: "F. Sporulation has occurred.",
      sporulationEnded: "G. Sporulation has ended.",
    },
    eventDotLabels: {
      sporangium: "Sporangium",
      zoospores: "Zoospores",
      dispersion: "Dispersion",
      notReceptive: "Not receptive",
      infection: "Infection",
      sporulation: "Sporulation",
      end: "End",
    },
    chart: {
      title: "Oospore germination and phases",
      familyLabel: "Fam. {n}",
    },
  },
  modelDashboard: {
    titlePlaceholder: "Dashboard title…",
    defaultTitle: "Model dashboard",
    refreshing: "Refreshing…",
    refreshAll: "Refresh all",
    finishEdit: "Done editing",
    editLayout: "Edit layout",
    emptyState: "No models. Click",
    emptyStateHint: "Edit layout → + Add",
    drag: "Drag",
    customize: "Customize",
    remove: "Remove",
    addModel: "Add model",
    noDataHint: "No data. Click",
    noDataHintSuffix: "to run the model.",
    addModalTitle: "Add model to dashboard",
    field: "Field",
    chooseField: "— choose field —",
    model: "Model",
    chooseModel: "— choose model —",
    defenseGroup: "Defense",
    mode: "Mode",
    cancel: "Cancel",
    customizeCardTitle: "Customize card",
    cardTitleLabel: "Title",
    save: "Save",
    modeCompact: "Compact",
    modeCard: "Card",
    modeFull: "Full",
  },
  dssModelsView: {
    pageTitle: "DSS Models",
    farmFallback: "Farm",
    field: "Field",
    chooseField: "— choose field —",
    model: "Model",
    chooseModel: "— choose model —",
    defenseGroup: "Defense",
    visualization: "Display",
    modeFull: "Full",
    modeCard: "Card",
    modeMicrocard: "Microcard",
    modeMobile: "Mobile",
    runModel: "Run model",
    hideJson: "Hide JSON",
    rawJson: "Raw JSON",
    forceRecalculate: "Force recalculation",
    advancedOptions: "Advanced options",
    runEndDate: "Run end date",
    runEndDateHint: "(empty = today / end of season)",
    active: "active",
    fieldLabel: "Field:",
    cropLabel: "Crop:",
    modelLabel: "Model:",
    cachedResult: "Result from cache",
    executionError: "Model execution error",
    badgeCard: "Card",
    cardPreviewNote: "Dashboard card preview — click to open full detail.",
    badgeMobilePreview: "Mobile preview",
    mobilePreviewNote:
      "Mobile viewport simulation (375px) — responsive layout handled via CSS.",
    badgeMicrocard: "Microcard",
    microcardPreviewNote: "Microcard preview — click to open full detail.",
    microcardHint: "← this is how it would appear in a cell or dashboard",
    placeholderHint: "Select field, model and mode, then click",
    breadcrumbDss: "DSS",
    breadcrumbTestModels: "Model test",
  },
  modelDashboardView: {
    pageTitle: "Model dashboard",
    farmFallback: "Farm",
    noSeasonSelected: "Select a season to view the dashboard.",
    debugLink: "debug",
    breadcrumbDss: "DSS",
    breadcrumbDashboard: "Dashboard",
  },
  modelStructure: {
    olivePheno: "Olive tree phenology",
    grapePheno: "Grapevine phenology",
    irrigation: "Irrigation",
    nutrition: "Fertilization",
    oliveFlyDss: "DSS Olive fruit fly",
    grapeLobesia: "European grapevine moth",
    grapePowdery: "Powdery mildew",
    grapePlasmo: "Downy mildew - 3-10 Goidanich",
    botrytis: "Botrytis",
    botrytisGonzalez: "Botrytis González (experimental)",
    plasmoPlus: "Downy mildew Plus - epidemiological model",
    plasmoMl: "Downy mildew Machine Learning - symptom risk",
    powderyMl: "Powdery mildew Machine Learning - symptom risk",
    botrytisMl: "Botrytis Machine Learning - symptom risk",
    maturation: "Ripening",
    cornDiabro: "Diabrotica virgifera",
    cornOstrinia: "Ostrinia nubilalis",
    cornHeli: "Helicoverpa armigera",
  },
  // ── Vocabolario tipi evento zoo (animal_custom_form.form_name, valore fisso da DB — vedi I18N_TODO.md) ──
  eventTypeVocab: {
    "Lattazione (IN/OUT)": "Lactation (IN/OUT)",
    Parto: "Birth",
    Salute: "Health",
    "Produzione Latte": "Milk Production",
    Razione: "Ration",
    "Interventi Sanitari": "Health Treatments",
    Urea: "Urea",
    Ecografia: "Ultrasound",
  },
  // ── Vocabolario colture (crop.name, valore fisso da DB — vedi I18N_TODO.md) ──
  cropVocab: {
    Abete: "Fir",
    Acero: "Maple",
    "Actinidia (Kiwi)": "Kiwi (Actinidia)",
    Aglio: "Garlic",
    Albicocco: "Apricot",
    Alloro: "Bay laurel",
    Amaranto: "Amaranth",
    Arachide: "Peanut",
    "Arborea generica": "Generic tree crop",
    "Arundo Donax": "Giant reed (Arundo donax)",
    Asparago: "Asparagus",
    Assenzio: "Wormwood",
    Avena: "Oat",
    Bambu: "Bamboo",
    Barbabietola: "Beet",
    Basilico: "Basil",
    Bosco: "Woodland",
    "Broccoletto o Cime Di Rapa": "Broccoli raab (turnip greens)",
    Calendula: "Calendula (Marigold)",
    Calla: "Calla lily",
    Canapa: "Hemp",
    Carciofo: "Artichoke",
    Cardi: "Cardoon",
    Carota: "Carrot",
    Castagno: "Chestnut",
    Cavolfiore: "Cauliflower",
    Cavolo: "Cabbage",
    "Cavolo Broccolo": "Broccoli",
    "Cavolo Rapa": "Kohlrabi",
    Cece: "Chickpea",
    Cedro: "Citron",
    Cetriolo: "Cucumber",
    "Chenopodium Quinoa": "Quinoa (Chenopodium quinoa)",
    Cicerchia: "Grass pea",
    Cicoria: "Chicory",
    Ciliegio: "Cherry",
    "Ciliegio Acido (Marasca,Visciola,Amarena)":
      "Sour cherry (Marasca, Morello)",
    "Cipolla Anche Di Tipo Lungo (Echalion)":
      "Onion (incl. long-type / Echalion)",
    Cipresso: "Cypress",
    Cocomero: "Watermelon",
    "Colture varie": "Miscellaneous crops",
    Colza: "Rapeseed (Canola)",
    Corbezzolo: "Strawberry tree",
    Coriandolo: "Coriander",
    Cotogno: "Quince",
    Elicriso: "Curry plant (Helichrysum)",
    "Erba Medica": "Alfalfa",
    "Erbacea generica": "Generic herbaceous crop",
    Erbaio: "Forage crop (mixed fodder)",
    Eucalipto: "Eucalyptus",
    Facelia: "Phacelia",
    Fagiolino: "Green bean",
    Fagiolo: "Bean",
    "Fagiolo Dall'Occhio": "Black-eyed pea",
    Farnia: "English oak (Pedunculate oak)",
    Farro: "Spelt",
    "Fave, Favino E Favette": "Broad beans (Fava)",
    "Festuca (Sp. Festuca Pratensis Huds.)": "Meadow fescue",
    Fico: "Fig",
    Finocchio: "Fennel",
    Fiordaliso: "Cornflower",
    Fragola: "Strawberry",
    Gelso: "Mulberry",
    "Giaggiolo (Iris) Pallida": "Iris pallida (Sweet iris)",
    "Giaggiolo o Giglio Bianco Iris Fiorentina":
      "Florentine iris (White lily iris)",
    Ginepro: "Juniper",
    Ginestrino: "Bird's-foot trefoil",
    Girasole: "Sunflower",
    Giuggiolo: "Jujube",
    "Grano (Frumento) Tenero": "Common wheat (soft wheat)",
    "Grano (Frumento) duro": "Durum wheat",
    "Grano Saraceno": "Buckwheat",
    "Grano Turanicum o Frumento Orientale o Grano Khorasan":
      "Khorasan wheat (Kamut)",
    "Indivia o Scarola": "Endive (Escarole)",
    Issopo: "Hyssop",
    Lampone: "Raspberry",
    "Lattuga Lattughino": "Lettuce (baby leaf)",
    Lavanda: "Lavender",
    Leccio: "Holm oak",
    Lenticchia: "Lentil",
    Limone: "Lemon",
    Lino: "Flax",
    "Loietto (Sp. Lolium X Boucheanum Kunt.)": "Hybrid ryegrass",
    "Loietto Loglio": "Ryegrass",
    "Loietto Loglio Perenne/Loietto Inglese":
      "Perennial ryegrass (English ryegrass)",
    "Loto (Kaki) (Compreso Il Caco Mela)": "Persimmon (Kaki)",
    Lupinella: "Sainfoin",
    Lupino: "Lupin",
    Luppolo: "Hops",
    "Lycium Barbarum (Goji)": "Goji berry (Lycium barbarum)",
    Mais: "Corn (Maize)",
    Mandorlo: "Almond",
    Melanzana: "Eggplant",
    Melissa: "Lemon balm",
    Melo: "Apple",
    Melograno: "Pomegranate",
    Melone: "Melon",
    Menta: "Mint",
    "Menta Piperita": "Peppermint",
    Miglio: "Millet",
    'Mirtilli Rossi, Mirtilli Neri Ed Altri Frutti Del Genere "Vaccinium"':
      "Cranberries, blueberries and other Vaccinium fruits",
    Mirto: "Myrtle",
    More: "Blackberries",
    Nespolo: "Medlar",
    Nocciolo: "Hazelnut",
    Noce: "Walnut",
    "Olivello o Olivello Spinoso": "Sea buckthorn",
    Olivo: "Olive",
    Orzo: "Barley",
    Panico: "Proso millet",
    "Pascolo Arborato - Tara 50%": "Wooded pasture (50% set-aside)",
    "Pascolo Polifita": "Mixed-species pasture",
    Passiflora: "Passionflower",
    Patata: "Potato",
    "Paulownia Tomentosa": "Paulownia (Paulownia tomentosa)",
    Peperoncino: "Chili pepper",
    Peperone: "Bell pepper",
    Pero: "Pear",
    Pesco: "Peach",
    "Pesco Nettarina": "Nectarine",
    "Piante Aromatiche E Medicinali E Spezie":
      "Aromatic, medicinal and spice plants",
    Pino: "Pine",
    "Pino Domestico": "Stone pine (Umbrella pine)",
    Pioppo: "Poplar",
    "Pioppo Bianco": "White poplar",
    Pisello: "Pea",
    Pistacchio: "Pistachio",
    Pomodoro: "Tomato",
    Porro: "Leek",
    "Prati Permanenti Naturali Con Vincoli Ambientali":
      "Permanent natural grassland with environmental constraints",
    "Prato In Rotolo (Tappeto Erboso)": "Turf (rolled lawn)",
    "Prato Pascolo": "Meadow pasture",
    "Prato Polifita": "Mixed-species meadow",
    Prezzemolo: "Parsley",
    Prugne: "Plums",
    Prugnolo: "Blackthorn (Sloe)",
    Radicchio: "Radicchio",
    Rafano: "Horseradish",
    Ravanello: "Radish",
    "Ribes Bianco (Uva Spina)": "White currant (Gooseberry)",
    "Ribes Nero": "Blackcurrant",
    "Ribes Rosso": "Redcurrant",
    Risone: "Paddy rice",
    Rosa: "Rose",
    "Rosa Canina": "Dog rose",
    Rosmarino: "Rosemary",
    Rucola: "Arugula (Rocket)",
    Ruscus: "Butcher's broom (Ruscus)",
    Salvia: "Sage",
    Scalogno: "Shallot",
    Sedano: "Celery",
    Senape: "Mustard",
    Soia: "Soybean",
    Sorbo: "Rowan (Sorb)",
    Sorgo: "Sorghum",
    Spinacio: "Spinach",
    "Sughera Quercia Da Sughero": "Cork oak",
    Sulla: "Sulla (Sulla clover)",
    Susino: "Plum tree",
    Tabacco: "Tobacco",
    Tartufo: "Truffle",
    Tiglio: "Linden (Lime tree)",
    Timo: "Thyme",
    Topinambur: "Jerusalem artichoke",
    Trifoglio: "Clover",
    "Trifoglio (Sp. Trifolium Alexandrinum L.)": "Egyptian clover (Berseem)",
    "Trifoglio (Sp. Trifolium Incarnatum L.)": "Crimson clover",
    "Trifoglio (Sp. Trifolium Pratense L.)": "Red clover",
    "Trifoglio (Sp. Trifolium Repens L.)": "White clover",
    "Trifoglio (Sp. Trifolium Resupinatum L.)": "Persian clover",
    "Trifoglio (Sp. Trifolium Squarrosum L.)": "Squarrose clover",
    Triticale: "Triticale",
    Vecce: "Vetches",
    "Veccia Sativa": "Common vetch",
    Viburno: "Viburnum",
    Vite: "Grapevine",
    Zafferano: "Saffron",
    Zucca: "Pumpkin (Squash)",
    Zucchino: "Zucchini",
  },
  // crop_operation.name / survey_schema.name vocabulary — see I18N_TODO.md.
  // Per-organization custom entries (created via AdminDbmngView) are not
  // listed here and fall back to the raw DB value (same pattern as cropVocab).
  schemaVocab: {
    "Altra operazione": "Other operation",
    "Concimazione Fogliare e Biostimolanti":
      "Foliar fertilization & biostimulants",
    Concimazione: "Fertilization",
    "Distribuzione effluenti": "Livestock manure application",
    Irrigazione: "Irrigation",
    "Lavorazione del suolo": "Soil tillage",
    Potatura: "Pruning",
    Raccolta: "Harvest",
    "Semina/Trapianto": "Sowing/Transplanting",
    Sovescio: "Green manure",
    Trattamenti: "Treatments",
    "Trattamenti mosca dell'olivo": "Olive fly treatments",
    "Botrite della vite": "Grape botrytis",
    Catture: "Trap catches",
    "Catture - Tignoletta della vite": "Catches - Grape berry moth",
    "Catture old": "Catches (old)",
    "Fenologia dell'olivo": "Olive phenology",
    "Fenologia della vite": "Grapevine phenology",
    "Infestazione - Tignoletta della vite": "Infestation - Grape berry moth",
    "Mosca dell'olivo - Infestazione completa": "Olive fly - Full infestation",
    "Mosca dell'olivo - Infestazione semplice":
      "Olive fly - Simple infestation",
    "Oidio della vite": "Grape powdery mildew",
    "Peronospora della vite": "Grape downy mildew",
    "Profondità di Falda": "Water table depth",
    propagazione: "Propagation",
    Sprouting: "Sprouting",
    Morfologia: "Morphology",
    Diameter: "Diameter",
    Agroduino: "Agroduino",
    Adversities: "Adversities",
    "prelievo snips": "Snips sampling",
    "Fisiologia e avversità": "Physiology and adversities",
    Spilocea: "Spilocaea",
    Fenologia: "Phenology",
    "Installa il cartellino": "Install the tag",
  },
  syncMonitor: {
    modalTitle: "Sync Status",
    sseConnection: "SSE Connection",
    connected: "Connected",
    disconnected: "Disconnected",
    network: "Network",
    online: "Online",
    offline: "Offline",
    lastDataSync: "Last data sync",
    never: "Never",
    lastVocabSync: "Last vocabulary sync",
    queuedRecords: "Queued records",
    lastPush: "Last push",
    recentFarmChanges: "Recent farm changes",
    hideJson: "Hide JSON",
    showJson: "Show JSON",
    close: "Close",
    recentErrors: "Recent errors ({count})",
    clear: "Clear",
    updateVocab: "Update Vocabularies",
    syncingLabel: "Syncing...",
    syncAll: "Sync All",
    clickForStatus: "Click to see sync status",
    statusChecking: "Checking...",
    statusUpdatingDefault: "Updating...",
    statusSynced: "Synced",
    statusUpdatedDefault: "Updated",
    statusError: "Error ({count})",
    statusReconnecting: "Reconnecting...",
    now: "now",
    minutesAgo: "{n} min ago",
    hoursAgo: "{n}h ago",
    daysAgo: "{n}d ago",
    neverSynced: "Never synced",
    resyncError: "Error during resync",
    vocabResyncError: "Error updating vocabularies",
    syncError: "Error during sync",
    syncFailed: "Sync failed",
    checkError: "Error checking for updates",
    updatingFarms: "Updating {n} {farms}...",
    updatedFarms: "Updated {n} {farms}",
    vocabUpdated: "Vocabularies updated",
    farmSingular: "farm",
    farmPlural: "farms",
  },
  invitationsBanner: {
    title: "Received Invitations",
    pendingSingular: "You have 1 pending invitation:",
    pendingPlural: "You have {n} pending invitations:",
    typeTeam: "Farm team",
    typeOrg: "Organization",
    invitedBy: "Invited by {name}",
    accept: "Accept",
    reject: "Decline",
    newProfileCreated:
      "New profile created. You will be able to select it at next login.",
  },
  invitationModal: {
    title: "Invitation received",
    invitedBy: "Invited by",
    acceptOrgDesc: "By accepting you will become part of this organization.",
    reject: "Decline",
    waiting: "Please wait…",
    accept: "Accept",
    acceptError: "Error while accepting invitation",
    alreadyHaveProfile: "You already have a profile in another organization.",
    newProfileWillBeCreatedFor:
      "By accepting, a new profile will be created for",
    switchProfileHint:
      "You will be able to switch between profiles using the profile selector at login.",
    cancel: "Cancel",
    creating: "Creating…",
    createNewProfile: "Create new profile",
    newProfileCreatedFor: "New profile created for",
    selectFromProfileMenu: "Select it from the profile menu at next login.",
    joinedOrg: "You joined the organization",
    close: "Close",
  },
  moscaCounter: {
    stingNo: "Sting NO",
    stingYes: "Sting YES",
    infestationAt: "Infestation at",
    stingsOutOfObserved: "{si} stings out of {total} observed olives",
    motivationFirst: "Observe your first olive..",
    motivationAtLeast50: "Observe at least 50 olives!",
    motivationKeepGoing: "Come on! Just a few more olives..",
    motivationAlmost100:
      "At this point why not? Can't you make it to 100 olives?!",
    motivationGreatJob: "🥳 Great job!",
  },
  moscaCompletaCounter: {
    totalObserved: "Total observed olives",
    eggs: "Eggs",
    warningTitle: "⚠️ Warning:",
    warningExceedsTotal:
      "The sum of infested stages ({infested}) exceeds the total olives ({total})",
    activeLabel: "Active (U+L1v+L2v)",
    harmfulLabel: "Harmful (L3v+L3m+Pv+Pm+Fu)",
    totalInfestations: "Total infestations",
  },
  activitySummary: {
    irrigation: "Irrigation",
    productKgHa: "{name}: {amount} kg/ha",
    fertilization: "Fertilization",
    organicFertilization: "Organic fertilization",
    greenManure: "Green manure",
    pruning: "Pruning",
    totalQty: "{qty} {uom} total",
    harvest: "Harvest",
    tillage: "Tillage",
    productDoseHa: "{name}: {dose} {uom}/ha",
    sowingTransplanting: "Sowing/Transplanting",
    treatment: "Treatment",
    insectsCount: "{n} insects",
    trapName: "Trap: {name}",
    trapMonitoring: "Trap monitoring",
    totAbbrev: "Tot",
    olivesCount: " ({n} olives)",
    fullFlySummary: "Full olive fly: {parts}{olives}",
    oliveFlyNoObservations: "Olive fly — no olives observed",
    oliveFlySummary:
      "Olive fly: {pct}% infestation ({si} stings out of {tot} olives)",
    phenology: "Phenology",
    birth: "Birth: {f}F {m}M{dead}",
    birthDead: " {dead} dead",
    ultrasound: "Ultrasound: {result}{days}",
    ultrasoundDaysExpected: ", {gg} days expected",
    lactation: "Lactation: from {start} to {end}",
    health: "Health: {type}",
    healthEvent: "Health event",
  },
  spadeQuestions: {
    ui: {
      newTestTitle: "New Spade Test",
      newTestSubtitle: "Enter the general sample information",
      sampleCode: "Sample code",
      sampleCodePlaceholder: "E.g. North Field — Point 1",
      date: "Date",
      latitude: "Latitude",
      latitudePlaceholder: "E.g. 43.6",
      longitude: "Longitude",
      longitudePlaceholder: "E.g. 10.6",
      gpsSearching: "Searching…",
      useGpsLocation: "Use GPS location",
      cancel: "Cancel",
      startTest: "Start test →",
      readInstructions: "Read the instructions above and proceed.",
      layerN: "Layer {n}",
      back: "← Back",
      saveExit: "Save and exit",
      next: "Next →",
      finish: "Finish →",
      testCompleted: "Test completed",
      soilQualityAvg: "Average soil quality:",
      hideLayerDetails: "Hide layer details",
      showLayerDetails: "Show layer details",
      slope: "Slope",
      fieldCover: "Field cover",
      texture: "Texture",
      shearResistance: "Shear resistance",
      notes: "Notes",
      additionalNotes: "Additional notes",
      notesPlaceholder: "Free observations about the sample…",
      reviewButton: "← Review",
      saveObservation: "Save observation",
      geoNotSupported: "Geolocation not supported by the browser",
      geoError: "Unable to get location: {message}",
      fillLayerAnswer: "Fill in the answer for Layer {n}",
      selectAnAnswer: "Select an answer",
      invalidLayerCount: "Enter a valid number of layers (1–10)",
      invalidLayerDepths: "Layer depths must be increasing integers",
      notAvailable: "N/A",
      shortLabel: {
        agshp: "Aggregates",
        comp: "Compactness",
        moist: "Moisture",
        typor: "Organic residues",
        decor: "Decomposition",
        smell: "Smell",
        rootp: "Roots",
        col: "Soil color",
        sq: "SQ quality",
      },
    },
    sqLabels: {
      1: "Excellent",
      2: "Good",
      3: "Average",
      4: "Poor",
      5: "Very poor",
    },
    questions: {
      fslo: {
        label: "What is the slope of the field?",
        answers: {
          flat: "Flat",
          low: "Low slope (<5%)",
          medium: "Medium slope (6–20%)",
          high: "High slope (21–60%)",
          very_high: "Very high (>60%)",
        },
      },
      fcov: {
        label: "What is the prevailing cover of the field?",
        answers: {
          bare_soil: "Bare soil",
          arable: "Arable crop",
          horticolture: "Horticultural crop",
          tree_crop: "Tree crop",
          forest: "Forest",
          grassland: "Grassland / Pasture",
        },
      },
      pcov: {
        label: "What does the sampling area contain?",
        answers: {
          crop: "Mostly crop",
          weeds: "Mostly weeds",
          soil: "Mostly bare soil",
        },
      },
      leg: {
        label: "Are you sampling a soil with legumes?",
        answers: {
          yes: "Yes",
          no: "No",
        },
      },
      sois: {
        label: "What do you observe on the soil surface?",
        help: "Select everything visible on the soil surface.",
        answers: {
          crust: "Surface crust",
          logging: "Waterlogging",
          erosion: "Signs of erosion",
          compaction: "Signs of compaction",
          algae: "Algae growth",
          cracks: "Cracks",
        },
      },
      wilpla: {
        label: "Do you see these wild plants at the sampling point?",
        help: "Select the species present in abundance.",
        answers: {
          stellaria: "Stellaria media",
          veronica: "Veronica spp.",
          galinsoga: "Galinsoga parviflora",
          capsella: "Capsella bursa-pastoris",
          urtica: "Urtica spp.",
          poa: "Poa annua",
          acalypha: "Acalypha virginica",
          echinochloa: "Echinochloa crus-galli",
          polygonum: "Polygonum aviculare",
          matricaria: "Matricaria chamomilla",
          plantago: "Plantago spp.",
          taraxacum: "Taraxacum officinale",
        },
      },
      info_sample: {
        label: "How to take the sample",
        help: "Insert the spade vertically into the soil to maximum depth. Lift the sample and place it on a flat surface. Identify the visible layers and proceed with observations layer by layer.",
      },
      ressli: {
        label: "How does the soil resist to the spade cut?",
        help: "Evaluate the resistance while inserting the spade.",
        answers: {
          easy: "Easy to cut to the full depth of the spade",
          hard_uniform: "Uniformly difficult to cut",
          hard_alternation: "Alternating easy and difficult parts",
        },
      },
      stext: {
        label: "What is the soil texture at the observation point?",
        answers: {
          sand: "Sandy",
          av_text: "Medium texture",
          clay: "Clayey",
        },
      },
      laynum: {
        label: "Enter the number of visible layers in the profile",
        help: "Count the number of distinct visible layers (usually 1–3, maximum 10).",
        placeholder: "E.g. 2",
      },
      laydep: {
        label: "How deep (cm) does each layer reach?",
        help: "Enter the cumulative depth from the surface for each layer. Values must be increasing.",
        placeholder: "Depth in cm",
      },
      agshp: {
        label: "What is the shape of the soil aggregates?",
        answers: {
          granular: "Granular",
          crumb: "Crumb",
          blocky_small: "Small blocky",
          blocky_large: "Large blocky",
          sub_blocky_small: "Small sub-blocky",
          sub_blocky_large: "Large sub-blocky",
          platy: "Platy",
          structureless: "Structureless",
        },
      },
      agdim: {
        label: "Most frequent aggregate size (mm)",
        placeholder: "Average size in mm",
      },
      comp: {
        label: "How compact is the soil layer?",
        answers: {
          loose: "Loose",
          lightly_compacted: "Lightly compacted",
          very_compacted: "Very compacted",
        },
      },
      moist: {
        label: "How moist is the soil?",
        help: "Take a handful of soil and try to break it with your hands.",
        answers: {
          dry: "Dry — does not break because too hard",
          wet: "Wet — does not break because plastic",
          good: "Optimal — breaks easily into aggregates",
        },
      },
      col: {
        label: "Looking at the soil color, do you see these signs?",
        answers: {
          ocra: "Ochre / rusty / black / white mottles",
          grey: "Grey-green-blue color",
        },
      },
      typor: {
        label: "What type of organic residues are present?",
        answers: {
          no_residues: "No residues",
          manure: "Manure or compost",
          residues: "Plant residues",
          straw: "Straw",
          roots: "Old roots",
        },
      },
      decor: {
        label: "How decomposed are the organic residues?",
        answers: {
          intact: "Intact (original recognizable)",
          medium_decomposed: "Medium decomposed (recognizable with difficulty)",
          well_decomposed: "Well decomposed (no longer recognizable)",
        },
      },
      smell: {
        label: "How does the soil smell?",
        answers: {
          no_smell: "No smell",
          good_smell: "Good (earthy / woody)",
          bad_smell: "Bad (putrefaction)",
        },
      },
      rootp: {
        label: "Do you see roots in the layer?",
        answers: {
          no_roots: "No roots",
          few_roots: "Very few roots",
          lot_roots: "Many roots",
        },
      },
      roott: {
        label: "Do you see legume nodules?",
        help: "Nodules are found on the roots. If open and red inside they are active (fix nitrogen).",
        helpImageCaptions: {
          0: "Legume with root nodules",
          1: "Open nodule (red = active)",
        },
        answers: {
          no_nodules: "No nodules",
          yes_few: "Yes, few",
          yes_many: "Yes, many",
          yes_not_red: "Yes, but not red when open",
        },
      },
      earthw: {
        label: "Do you see signs of earthworms?",
        answers: {
          earthworm: "Earthworm",
          hole: "Burrow / Hole",
          cast: "Cast (cylindrical)",
        },
      },
      biodivoth: {
        label: "Do you see signs of other soil fauna?",
        answers: {
          beetles: "Beetles",
          soil_centipedes: "Soil centipedes",
          tropical_centipedes: "Tropical centipedes",
          millipedes: "Millipedes",
          beetle_larvae: "Beetle larvae",
        },
      },
      sq: {
        label: "How do you rate this layer overall?",
        help: "1 = excellent structural quality, 5 = very poor quality.",
        answers: {
          1: "1 — Excellent",
          2: "2 — Good",
          3: "3 — Average",
          4: "4 — Poor",
          5: "5 — Very poor",
        },
      },
      note: {
        label: "Additional notes",
        placeholder: "Additional observations about the sample...",
      },
    },
  },
  plantSurveyEditor: {
    changeSchemaMode: "Change schema/mode",
    validateData: "Validate Data",
    saving: "Saving...",
    saveChanges: "Save Changes",
    step1SelectSchema: "1. Select Survey Schema",
    loadingSchemas: "Loading schemas...",
    noSchemasAvailable: "No schema available",
    selectSchemaPlaceholder: "Select schema...",
    step2SelectMode: "2. Select Mode",
    modeTable: "Table",
    modeGrid: "Grid",
    step3SelectVariable: "3. Select Variable",
    proceed: "Proceed",
    insert: "Insert",
    edit: "Edit",
    attention: "Warning:",
    orphanedSurveysMessage:
      "There are {n} surveys linked to plants that no longer exist.",
    deleteOrphanedSurveys: "Delete orphaned surveys",
    unsavedChangesWarning:
      "You have unsaved changes. Save before changing mode or navigating away, otherwise the data will be lost.",
    exitFullscreen: "Exit fullscreen",
    fullscreen: "Fullscreen",
    validationCompleted: "Validation Completed",
    validationErrorsTitle: "Validation Errors",
    errorsLabel: "Errors:",
    newRecords: "New records",
    modifiedRecords: "Modified records",
    deletedRecords: "Deleted records",
    total: "Total",
    dataValidReadyToSave: "The data is valid and ready to be saved.",
    close: "Close",
    confirmAndSave: "Confirm and Save",
    columnRow: "Row",
    columnColumn: "Column",
    columnAccession: "Accession",
    columnVariety: "Variety",
    columnSurveyDate: "Survey Date",
    columnDate: "Date",
    duplicateRecordError:
      "Error: duplicate records found for the same plant on date {date}",
    confirmDiscardModeChange:
      "You have unsaved changes. Changing mode will lose the data. Continue?",
    confirmDiscardDateChange:
      "You have unsaved changes. Changing date will reload the data and lose the changes. Continue?",
    confirmDiscardGoBack:
      "You have unsaved changes. Going back will lose the data. Continue?",
    confirmLeavePage:
      "You have unsaved changes that will be lost. Do you want to leave the page?",
    noVariableSelectedForGrid: "No variable selected for grid mode",
    noDataToSave: "No data to save",
    duplicatePlantCode: "Duplicate plant code: {code}",
    saveErrorMessage: "Error while saving: {message}",
    modifiedCell: "Modified",
    unnamedSchema: "Unnamed schema",
    schemaHasDataLabel: "{name}  ·  has data",
  },
  plantManager: {
    plantsCreated: "Plants created",
    createPlants: "Create Plants",
    saveConfiguration: "Save Configuration",
    resetPlants: "Reset Plants",
    removeAccessions: "Remove Accessions",
    map: "Map",
    table: "Table",
    guidedConfiguration: "Guided configuration",
    firstPlantFirstRow: "First plant of the first row",
    clickMapStartingPoint: "Click on the map to place the starting point",
    lastPlantFirstRow: "Last plant of the first row",
    clickMapRowDirection:
      "Click on the map to define the direction and length of the row",
    directionLengthCalculated: "Direction and length calculated",
    plantsPerRow: "Plants per row",
    spacing: "Spacing",
    number: "Number",
    rowSpacingLabel: "Spacing along the row (m)",
    plantsPerRowLabel: "Plants per row",
    next: "Next",
    mBetweenPlants: "{n} m between plants",
    nPlants: "{n} plants",
    firstPlantLastRow: "First plant of the last row",
    clickMapRowSpacingDirection:
      "Click on the map to define the direction and distance between rows",
    rowSpacingCalculated: "Row spacing calculated",
    numberOfRows: "Number of rows",
    interRow: "Row spacing",
    rowDistanceLabel: "Distance between rows (m)",
    numberOfRowsLabel: "Number of rows",
    finishConfiguration: "Finish configuration",
    back: "← Back",
    cancel: "Cancel",
    gridConfiguration: "Grid Configuration",
    startGuidedWizard: "Start guided wizard",
    numberOfFiles: "Number of Rows",
    betweenRows: "Between rows (m)",
    onTheRow: "Along the row (m)",
    rotationDegrees: "Rotation (degrees)",
    layoutType: "Layout Type",
    rectangular: "Rectangular",
    quincunx: "Quincunx",
    startingPoint: "Starting point",
    firstPlantFirstRowDesc: "First plant of the first row.",
    cancelSelection: "Cancel selection",
    chooseOnMap: "Choose on map",
    remove: "Remove",
    plotCentroid: "Plot centroid",
    selectMarkingMode:
      "Select a mode to mark plants, or click a plant to see its details.",
    info: "Info",
    nonExisting: "Non-existent",
    dead: "Dead",
    totalPositions: "Total positions",
    existingPlants: "Existing plants",
    layoutSpacing: "Layout (Spacing)",
    estimatedArea: "Estimated Area",
    density: "Density",
    plantsPerHa: "plants/ha",
    noPlantsGenerated: "No plants generated.",
    accessions: "Accessions",
    withAccession: "With accession",
    uploadAccessionsExcel: "Upload Accessions (Excel)",
    downloadTemplateHelp:
      "Download the Excel template, fill it in and re-upload it to associate the accessions.",
    generating: "Generating...",
    downloadTemplate: "Download Template",
    instructionsTitle: "Fill-in instructions",
    howToFillIn: "? How to fill in",
    excelFile: "Excel File",
    checking: "Checking...",
    checkFile: "Check File",
    uploading: "Uploading...",
    uploadAccessions: "Upload Accessions",
    downloadFileWithErrors: "Download file with highlighted errors",
    surveys: "Surveys",
    totalSurveys: "Total surveys",
    noSurveysPresent: "No surveys present",
    manageSurveys: "Manage Surveys",
    viewData: "View Data ({n})",
    updateAccessionsExcel: "Update Accessions (Excel)",
    downloadExistingExcelHelp:
      "Download the Excel file with the accessions already uploaded, edit it and re-upload it.",
    downloadExcel: "Download Excel",
    updateAccessions: "Update Accessions",
    varieties: "Varieties",
    withoutAccession: "Without accession",
    nonExistingPlants: "Non-existent plants",
    present: "Present",
    edit: "edit",
    variety: "Variety",
    notAvailable: "N/A",
    origin: "Origin",
    date: "Date",
    notes: "Notes",
    noAccessionAssociated: "No accession associated",
    confirmCreatePlantsTitle: "Confirm plant creation",
    willCreatePlants: "This will create",
    plantsForThisPlot: "plants for this plot.",
    gridParamsWillBeSaved: "The grid parameters will be saved to the plot.",
    creating: "Creating...",
    confirm: "Confirm",
    confirmResetPlantsTitle: "Confirm plant reset",
    willDeleteAllExisting: "All",
    existingPlantsLower: "existing plants will be deleted.",
    cannotProceed: "Cannot proceed:",
    thereAreSurveysLinked: "there are {n} surveys linked to these plants.",
    deleteThemFirst: "Delete them first.",
    goToSurveyManagement: "Go to survey management",
    afterResetHelp:
      "After the reset you can modify the parameters and recreate the plants. This operation cannot be undone.",
    deleting: "Deleting...",
    deletePlants: "Delete Plants",
    removeAccessionsTitle: "Remove accessions",
    willRemoveAllAssociations:
      "All associations between plants and accessions for this plot will be removed.",
    accessionsUsedOnlyHere:
      "Accessions used only by this plot will be deleted. The plants will remain.",
    removing: "Removing...",
    confirmRemoval: "Confirm Removal",
    excelInstructionsTitle: "Excel Fill-in Instructions",
    sectionAAccessionsSheet: "A — Accessions Sheet",
    accessionsSheetIntro:
      "Enter one row for each accession (distinct individual/clone).",
    fieldCol: "Field",
    requiredCol: "Req.",
    descriptionCol: "Description",
    codeInternalDesc: "Short, simple code (e.g.",
    codeInternalDesc2: "). Used in the",
    codeInternalDesc3: "sheet to populate the plant matrix.",
    codeAccessionDesc:
      "Official identification code of the accession. At least 6 characters, must be unique.",
    codeVarietyDesc: "Name of the variety associated with this accession.",
    sourceDesc: "Origin of the accession (free text, e.g.",
    dateAccessionDesc: "Acquisition date of the accession in the format",
    varietyFlagNew:
      "insert the variety into the database if it does not exist yet.",
    varietyFlagOk: "you are certain of the variety assignment.",
    varietyFlagUncertain: "uncertain variety assignment.",
    noteFieldDesc: "Free notes about the accession. Optional field.",
    messageFieldDesc:
      "Do not fill in. Automatically populated by the system with any error messages.",
    sectionBPlantsSheet: "B — Plants Sheet",
    plantsSheetIntro:
      "The matrix represents the physical grid of the vineyard/orchard. Each cell corresponds to a plant.",
    plantsSheetBullet1Pre: "For each plant enter the",
    plantsSheetBullet1Post:
      "of the corresponding accession (the one defined in the Accessions sheet).",
    plantsSheetBullet2Pre: "If the plant is not present write",
    plantsSheetBullet2Mid: "; if it is dead write",
    plantsSheetBullet2Post: ".",
    close: "Close",
    legacyFormatDetectedTitle: "Legacy data format detected",
    legacyFormatDesc:
      "This plot uses the old grid configuration format. Do you want to convert it to the new format?",
    parameterCol: "Parameter",
    legacyValueCol: "Legacy value",
    newFieldCol: "New field",
    filesRows: "Rows",
    plantsPerRowCols: "Plants per row (columns)",
    interRowDistance: "Inter-row distance (m)",
    onRowDistance: "Distance along the row (m)",
    angleBearing: "Angles (bearing)",
    filesLabel: "Rows",
    columnsLabel: "Columns",
    ignore: "Ignore",
    convertToNewFormat: "Convert to new format",
    home: "Home",
    farms: "Farms",
    plants: "Plants",
    plantManagementTitle: "Plant Management",
    rowColHeader: "Row",
    colHeader: "Col",
    codeHeader: "Code",
    statusHeader: "Status",
    accessionHeader: "Accession",
    varietyHeader: "Variety",
    notesHeader: "Notes",
    errorGeneratingTemplate: "Error generating template",
    errorGeneratingTemplateRetry:
      "Plants not synced to the server yet. Please wait a few seconds and try again. ({msg})",
    errorPrefix: "Error: {msg}",
    errorSaving: "Error saving: {msg}",
    gridParamsSaved: "Grid parameters saved.",
    errorCreating: "Error creating: {msg}",
    partialCreateError:
      "Only {count} of {total} requested plants were created. {msg}",
    plantsCreatedSuccess: "Created {count} plants.",
    cannotDeletePlantsSurveys:
      'Cannot delete plants: there are {n} surveys linked. Delete the surveys first from the "Plant Surveys" section.',
    errorDeleting: "Error deleting: {msg}",
    plantsDeletedSuccess:
      "Plants deleted. You can now modify the parameters and recreate the plants.",
    plotLayerName: "Plot",
    guideLinesLayerName: "Guide lines",
    guidePointsLayerName: "Guide points",
    gridPreviewLayerName: "Grid preview",
    rowPreviewLayerName: "Row preview",
    plantsLayerName: "Plants",
    schemaFallback: "Schema {id}",
  },

  // ── Zoo / Livestock (HerdHome) ────────────────────────────────────────────────
  herdHome: {
    deleteHerd: "Delete herd",
    confirmDeletePermanent: "Delete permanently?",
    herdList: "Herds",
    bleReader: "BLE Reader",
    dashboard: "Dashboard",
    rations: "Rations",
    fertility: "Fertility",
    warningSpeciesTested:
      "Warning: the system has been tested mainly on sheep herds. Some features may not be fully supported for other species.",
    headsFiltered: "{filtered} / {total} heads",
    headsActive: "{count} active heads",
    exportBdn: "Export BDN",
    importBdn: "Import from BDN",
    allSexes: "All sexes",
    allBreeds: "All breeds",
    allAges: "All ages",
    allGroupsFilter: "All groups",
    withoutGroupFilter: "Without group",
    age0_6: "< 6 months",
    age6_24: "6–24 months",
    age2_6: "2–6 years",
    age6plus: "> 6 years",
    reset: "Reset",
    noAnimalsFiltered: "No animals match the filters.",
    filters: "Filters",
    exitedAnimals: "Exited animals ({count})",
    exportAllTitle: "Export all (active + exited)",
    exportAll: "Export all",
    noExitedAnimals: "No exited animals.",
    exitColumn: "Exit",
    confirmRestore: "Restore {code}?",
    farmFallback: "Farm",
  },

  // ── Zoo / Livestock (HerdUpsert) ──────────────────────────────────────────────
  herdUpsert: {
    titleNew: "New Herd",
    titleEdit: "Edit Herd",
    saving: "Saving...",
    herdData: "Herd data",
    species: "Species",
    namePlaceholder: "E.g. Dairy sheep",
    herdCode: "Herd code (BDN)",
    herdCodePlaceholder: "E.g. IT-0123456",
    unassignedAnimalsTitle: "Animals without a herd found",
    migratePrompt:
      'There are {count} animals of species "{specie}" not yet associated with a herd. Do you want to associate them with this herd?',
    notNow: "Not now",
    migrateConfirm: "Associate {count} animals",
    nameRequired: "Name is required",
    speciesRequired: "Species is required",
    farmFallback: "Farm",
    newHerdBreadcrumb: "New herd",
  },

  // ── Zoo / Livestock (EventUpsertForm) ─────────────────────────────────────────
  eventUpsertForm: {
    eventType: "Event type",
    noSchemaAvailable:
      "No schema available for this event type for the species",
    saving: "Saving...",
    dateLabel: "Date",
    selectEventType: "Select the event type.",
    exhaustedSuffix: " (out of stock)",
    lastEvent: "Last event",
    viewHistory: "View full history",
    eventHistory: "Event history",
    noPastEvents: "No past events.",
    close: "Close",
  },

  // ── Zoo / Livestock (ZooHome) ─────────────────────────────────────────────────
  zooHome: {
    titleWithFarm: "Livestock — {name}",
    bleReader: "BLE Reader",
    newHerd: "+ New herd",
    emptyTitle: "No herd configured",
    emptyDesc: "Create your first herd to start managing your animals.",
    createFirstHerd: "Create first herd",
    headCount: "{count} heads",
    groupCount: "{count} groups",
    farmFallback: "Farm",
  },

  // ── Zoo / Livestock (EventUpsert) ─────────────────────────────────────────────
  eventUpsert: {
    titleEdit: "Edit Event",
    saving: "Saving...",
    groupLabel: "Group",
    noGroupOption: "— no group —",
    farmFallback: "Farm",
    zooHomeBreadcrumb: "Livestock Home",
    animalFallback: "Animal",
    editEventBreadcrumb: "Edit event",
    newEventBreadcrumb: "New event",
    goToAnimal: "Go to animal record",
  },

  // ── Zoo / Livestock (FertilityDashboard) ─────────────────────────────────────
  fertilityDashboard: {
    pageTitlePrefix: "Fertility",
    herdDefault: "Herd",
    dashboardTitle: "Fertility Dashboard",
    periodKpi: "KPI Period:",
    period6: "Last 6 months",
    period12: "Last year",
    period24: "Last 2 years",
    periodAll: "Whole herd lifetime",
    activeFemales: "Active females",
    fertility: "Fertility",
    fertilitySub: "(females with positive ultrasound / total females)",
    prolificity: "Prolificacy",
    prolificitySub: "(offspring/delivery in the period)",
    deliveriesInPeriod: "Deliveries in period",
    bornInPeriod: "Born in period",
    tabFemales: "Female Heads",
    tabPregnancies: "Pregnancies",
    tabEco: "Ultrasounds",
    tabDeliveries: "Deliveries",
    femaleHeadsCount: "{n} female heads",
    downloadCsv: "Download CSV",
    pregnanciesRegistered: "{n} pregnancies registered — {period}",
    onlyOpenFuture: "Only ongoing / future",
    noPregnancies: "No pregnancy detected from ultrasounds.",
    daysAbbrev: "days",
    nBorn: "{n} born",
    examsCount: "{n} exams — {period}",
    noEcoInPeriod: "No ultrasound in the selected period.",
    deliveriesCount: "{n} deliveries — {period}",
    noDeliveriesInPeriod: "No delivery in the selected period.",
    periodLabelAll: "whole herd lifetime",
    periodLabel6: "last 6 months",
    periodLabel12: "last year",
    periodLabel24: "last 2 years",
    periodLabelN: "last {n} months",
    colBirth: "Birth",
    colEcoPos: "Positive US",
    colEcoPosDates: "Positive US dates",
    colLastEco: "Last US",
    colBornTotal: "Born tot.",
    colBornM: "Born ♂",
    colBornF: "Born ♀",
    colAnimal: "Animal",
    colEcoList: "Ultrasounds (date · days · expected)",
    colExpectedDelivery: "Expected delivery",
    colActualDelivery: "Actual delivery",
    colStatus: "Status",
    colDate: "Date",
    colGestDays: "Gest. days",
    colGestationDays: "Gestation days",
    colBornCount: "N. born",
    colBornCountM: "N. born ♂",
    colBornCountF: "N. born ♀",
    breadcrumbFarms: "Farms",
    breadcrumbFarmDefault: "Farm",
    statusDelivered: "Delivered",
    statusOverdue: "Overdue {n} days",
    statusIn: "In {n} days",
    statusExpected: "Expected",
    formsNotFound:
      "Forms not found (ultrasound: {eco}, delivery: {delivery}). Check the custom_form field in animal_custom_form.",
    loadErrorMsg: "Error loading data: {msg}",
  },

  // ── Zoo / Livestock (RationsDashboard) ───────────────────────────────────────
  rationsDashboard: {
    pageTitlePrefix: "Rations",
    herdDefault: "Herd",
    dashboardTitle: "Rations Dashboard",
    step1Title: "1. Feeds",
    step2Title: "2. Rations",
    step3Title: "3. Assignments",
    feedsConfigured: "{n} feed(s) configured",
    addAtLeastOneFeed: "Add at least one feed",
    rationsDefined: "{n} ration(s) defined",
    createRationWithFeeds: "Create a ration with the feeds",
    assignmentsActive: "{n} active assignment(s)",
    assignRationToGroup: "Assign a ration to a group",
    feedsInWarehouse: "Feeds in warehouse",
    newFeed: "New feed",
    editFeed: "Edit feed",
    noFeedConfigured: "No feed configured. Add feed, hay, supplements…",
    uom: "UoM",
    warehouseResidual: "Warehouse residual",
    rationsDefinedTitle: "Defined rations",
    newRation: "New ration",
    editRation: "Edit ration",
    addFeedFirst: "First add at least one feed (step 1).",
    noRationDefined: "No ration defined. Create a ration combining the feeds.",
    ration: "Ration",
    ingredientsPerHeadPerDay: "Ingredients (qty/head/day)",
    head: "head",
    newAssignmentTitle: "New ration assignment",
    defineRationFirst: "First define at least one ration (step 2).",
    noGroupInHerd: "No group in the herd.",
    selectGroup: "Select group",
    registerAssignment: "Register ration assignment",
    currentSituation: "Current situation",
    activeAssignments: "Active assignments",
    groupsUnderRation: "Groups under ration",
    totalDailyConsumption: "Total daily consumption",
    firstShortageIn: "First shortage in",
    rationAssignments: "Ration assignments",
    totalCount: "{n} total",
    noAssignmentRegistered: "No assignment registered.",
    from: "From",
    to: "To",
    headsEstimate: "Heads (estimate)",
    qtyPerDay: "Qty/day",
    status: "Status",
    statusActive: "Active",
    statusPast: "Ended",
    statusFuture: "Future",
    consumptionProjectionTitle:
      "Ingredient consumption projection (active assignments)",
    ingredient: "Ingredient",
    currentResidual: "Current residual",
    daysToEnd: "Days to end",
    residualPlus7d: "Residual +7d",
    residualPlus30d: "Residual +30d",
    residualPlus90d: "Residual +90d",
    projectionNote:
      "Projection based on the current group consistency. The residual decreases every day based on the estimated consumption of active assignments.",
  },

  // ── Zoo / Livestock (MilkQualityCard) ────────────────────────────────────────
  milkQualityCard: {
    title: "Milk Quality",
    expand: "Expand",
    minimize: "Minimize",
    noData: "No milk analysis available.",
    monthlyTrend: "{varLabel} — monthly trend",
    selectVariableHint: "Select a variable to see the chart",
    varBacterialLoad: "Bacterial Load",
    varSomaticCells: "Somatic Cells",
    varFat: "Fat %",
    varProtein: "Protein %",
    varUrea: "Urea mg/dl",
    varAvgProd: "Avg. prod. kg/d",
    varAdultSheep: "Adult sheep",
    dataNotAvailable: "Data not available",
    valuesOutOfRange: "Values out of range",
    valuesOptimal: "Optimal values",
    valuesIntermediate: "Intermediate values",
    tileHealth: "Health",
    qualityHigh: "High quality",
    qualityMedium: "Medium quality",
    qualityLow: "Low quality",
    tileMilkQuality: "Milk quality",
    feedLowProtein: "Low-protein feeding",
    feedHighProtein: "High-protein feeding",
    feedBalanced: "Balanced feeding",
    tileNutrition: "Nutrition",
    tileProductivity: "Productivity",
    kgPerSheep: "{n} kg/d per sheep",
    monthAbbrevs: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    currentYear: "Current year",
    lastYear: "Last year",
    zoneAverage: "Zone average",
  },

  // ── Zoo / Livestock (BluetoothScanner) ───────────────────────────────────────
  bluetoothScanner: {
    deviceConnected: "Device connected",
    disconnect: "Disconnect",
    lastCodeRead: "Last code read",
    messagesReceived: "Messages received",
    simulated: "simulated",
    listeningChannel: "Listening channel",
    none: "none",
    service: "Service",
    listening: "Listening",
    testMode: "Test Mode",
    simulateDesc: "Simulate a bolus reading without a physical reader",
    simulateBolusReading: "Simulate Bolus Reading",
    stressTest: "Stress test (50 rapid reads)",
    stressTestRunning: "Stress test running...",
    spoofRandomCode:
      "Test: replace read code with a random real one (useful with only one bolus)",
    scanningInProgress: "Scanning...",
    startBluetoothScan: "Start Bluetooth scan",
    searchingDevices: "Searching for devices...",
    devicesFound: "Devices found ({n})",
    hideAnonymous: "Hide anonymous",
    seeAllAnonymous: "See all (+ {n} anonymous)",
    noDeviceFound: 'No device found. Press "Start scan" to search.',
    webOnlyMsg:
      'Bluetooth scanning is only available on the mobile app. Use "Simulate Bolus Reading" to test the flow.',
    errorInit: "Bluetooth initialization error. Check that it is active.",
    errorNoDeviceRetry: "No device found. Try again.",
    errorScan: "Error during scanning. Check that Bluetooth is active.",
    connecting: "Connecting...",
    deviceConnectedExclaim: "Device connected!",
    errorConnect: "Error connecting to the device.",
    channelUpdated: "Channel updated",
    errorChannelChange: "Error changing channel.",
    deviceDisconnected: "Device disconnected",
    simulatedCode: "Simulated code: {code}",
    errorSimulation: "Error during simulation.",
  },
  bluetoothPage: {
    title: "Bluetooth Reader",
    infoText:
      "Use this feature to read animal boluses via Bluetooth readers (RS420, Petscan etc...). The code read is automatically associated with the corresponding animal.",
    quickAction: "Quick action",
    quickActionDesc: "When a bolus is read, go directly to register this event",
    firstAvailableForm: "— First available form —",
    recentReadings: "Recent readings",
    synced: "Synced",
    toSync: "To sync",
  },
  herdStats: {
    manageGroups: "Manage groups",
    total: "TOTAL",
    totalHeads: "Total Heads",
    groups: "Groups",
    maleAbbrev: "M",
    femaleAbbrev: "F",
    youngAbbrev: "Young",
    newGroup: "New group",
    groupDynamics: "Group dynamics",
    females: "Females",
    males: "Males",
    young: "Young",
    adultFemales: "Adult females",
    adultMales: "Adult males",
    noAge: "No age",
    headsUnit: "heads",
  },
  useBluetooth: {
    noHerdConfigured:
      "No herd configured. Configure a herd before adding animals via Bluetooth.",
    chipReader: "Chip Reader",
    cellIride: "Cell Iride",
  },
  useZooUtils: {
    yearsCount: "{n} year | {n} years",
    monthsCount: "{n} month | {n} months",
    lessThanOneMonth: "less than 1 month",
    codeRequired: "Code is required",
    codeTooShort: "Code too short (minimum 3 characters)",
    typeIn: {
      N: "Born in herd",
      M: "Purchased from Italian farm",
      R: "First registration",
      C: "Purchased from EU countries with coupon",
      E: "Purchased from EU countries",
      F: "Purchased from fair or market",
      G: "Purchased from genetic center",
      I: "Purchased from stable",
      K: "Purchased from collection center",
      L: "Purchased from staging stable",
      P: "Returned from pasture",
      Q: "Transferred without purchase",
      S: "Returned from foreign country",
      T: "Purchased from third countries",
      V: "Returned from fair, sale failed",
      W: "Born in herd (twin birth)",
    },
    typeOut: {
      D: "Died/Culled/Slaughtered on farm",
      M: "Sent to slaughter",
      A: "Sold for personal consumption",
      C: "Administrative cancellation",
      E: "Sold to a foreign country",
      F: "Theft/loss",
      G: "Sent to genetic center",
      H: "Theft",
      I: "Sent to stable",
      J: "Exit from pasture to pasture",
      K: "Sent to collection center",
      L: "Identified individually",
      N: "Not specified",
      P: "Sent to pasture",
      Q: "Slaughtered for personal consumption",
      R: "Sent to circus",
      S: "Sent to staging stable",
      T: "Transferred without sale",
      U: "Sent to a fair",
      V: "Sold to Italian farm",
      W: "Loss",
    },
  },

  // ── Zoo / Livestock (Animal & Group views) ───────────────────────────────────
  animalUpsert: {
    titleEdit: "Edit animal",
    saving: "Saving...",
    sectionIdentification: "Identification",
    sectionEntry: "Entry",
    sectionBiological: "Biological data",
    sectionGenetics: "Genetics",
    sectionNotes: "Notes",
    removeName: "Remove name",
    assignName: "Assign name",
    codePlaceholder: "e.g. IT001234567890",
    namePlaceholder: "Animal name (optional)",
    codeBdnPlaceholder: "BDN code",
    farmOriginPlaceholder: "Farm of origin",
    notePlaceholder: "Additional notes...",
    generate: "Generate",
    farmOrigin: "Farm of origin",
    scrapieLabel: "Scrapie genotype",
    scrapieNone: "— None —",
    dangerDeleteLink: "Permanently delete this animal",
    sexRequired: "Sex is required",
    confirmHardDelete:
      "Are you sure you want to permanently delete this animal? This action cannot be undone.",
    breedUnknown: "— Unknown —",
    groupNone: "— No group —",
  },
  animalRemove: {
    title: "Register exit",
    warningExit: "You are about to register this animal's exit from the herd.",
    inGroupPrefix: "This animal is part of the group",
    removeFromGroup: "Also remove from group",
    reasonLabel: "Exit reason",
    confirmExit: "Confirm exit",
  },
  addAnimalsView: {
    title: "Add animals",
    uploadCardTitle: "Upload animal list",
    helpText: "Paste or upload a file with the list of animals to import.",
    tabPaste: "Paste text",
    tabFile: "Upload file",
    pastePlaceholder: "Paste animal data here...",
    dropHint: "Drop a file here or click to select one",
    parsing: "Parsing...",
    parseBtn: "Parse",
    statNew: "New",
    statUpdates: "Updates",
    statMissing: "Missing",
    fileAnimalsTitle: "Animals in file ({count})",
    colSpecie: "Species",
    colStatus: "Status",
    missingTitle: "Missing animals ({count})",
    missingWarning:
      "These animals are present in the herd but not in the uploaded file.",
    bulkActionLabel: "Action for all",
    keepOption: "Keep",
    exitOption: "Mark exit",
    applyBulk: "Apply",
    colAction: "Action",
    colReason: "Reason",
    keepShort: "Keep",
    importBtn: "Import {count} animals",
    doneTitle: "Import complete",
    importingTitle: "Importing...",
    doneSummary: "{count} animals imported successfully.",
    errorsSummary: "{count} errors during import.",
    backToHerd: "Back to herd",
    herdFallback: "Herd",
    breadcrumbTitle: "Add animals",
    rowUpdate: "Update",
    parseError: "Error while parsing data.",
  },
  groupUpsert: {
    randomColor: "Random",
    nameRequired: "Group name is required.",
  },
  groupAddAnimals: {
    searchPlaceholder: "Search by code or name...",
    countLabel: "{selected} selected · {available} available",
    addButton: "Add {count} animals",
  },
  groupDynamicsView: {
    title: "Group dynamics",
    noData: "No data available for the selected period.",
    colDate: "Date",
    period3m: "3 months",
    period6m: "6 months",
    period12m: "12 months",
    periodAll: "All",
    tabChart: "Chart",
    tabTable: "Table",
    yAxisTitle: "No. of animals",
  },
  groupList: {
    dynamics: "Dynamics",
    detail: "Detail",
    description: "Description",
    headCount: "head",
    confirmDelete: 'Delete group "{name}"?',
  },
  groupEventUpsert: {
    titleEdit: "Edit group event",
    titleNew: "New group event",
    headerEdit: "Edit event",
    headerNew: "New event",
  },
  animalDetail: {
    notFound: "Animal not found.",
    exitedBanner: "Animal exited",
    panelHistory: "History",
    registryDataHeader: "Registry data",
    currentGroupHeader: "Current group",
    move: "Move",
    exit: "Exit",
    assignToGroup: "Assign to group",
    since: "since",
    noEventsOrMovements: "No events or movements recorded.",
    moveModalTitle: "Move to another group",
    exitModalTitle: "Exit group",
    removeFromGroupPrefix: "Remove",
    removeFromGroupMiddle: "from group",
    loadingGroups: "Loading groups...",
    noGroupsAvailable: "No groups available.",
    confirmExit: "Confirm exit",
    deleteMembershipTitle: "Delete membership data",
    deleteMembershipWarning:
      "This operation permanently deletes the group membership data.",
    deleteMembershipConfirmPrefix: "Delete the membership data for group",
    deleteDataButton: "Delete data",
    eventDetailTitle: "Event detail",
    close: "Close",
    groupEventSubtitle: "Group event",
    groupEntryTitle: 'Entered group "{group}"',
    groupExitTitle: 'Exited group "{group}"',
    confirmRestore: "Restore {code}?",
    confirmDeleteEvent: "Delete this event?",
  },
  groupDetail: {
    eventsTab: "Events",
    exitSelected: "Exit selected ({count})",
    exitedSingleWarning:
      "Animal {code} has exited the herd ({typeOut}) — remove it from the group.",
    exitedMultiWarning:
      "{count} animals have exited the herd — remove them from the group.",
    exitGroupAt: "Exit group on",
    hidePast: "Hide",
    pastMembers: "Past members",
    noPastMembers: "No past members.",
    notFound: "Group not found.",
    exitModalTitle: "Exit group",
    inGroupSince: "in group since",
    selectedAnimals: "{count} animals selected",
    exitDateLabel: "Exit date",
    destinationLabel: "Destination",
    saving: "Saving...",
    confirmExitBtn: "Confirm exit",
    colInGroupSince: "In group since",
    colHerdExit: "Herd exit",
    noGroupOption: "— No group —",
    confirmForceExit:
      "Remove {name} from the group at the herd exit date ({date})?",
    dateRequired: "Date is required.",
    dateBeforeEntry: "Exit date cannot be before entry date.",
  },
  zooStore: {
    cannotDeleteAnimalHasEvents:
      "Cannot delete: the animal has registered events. Delete them first.",
    cannotDeleteAnimalHasMemberships:
      "Cannot delete: the animal has group memberships. Remove it from groups first.",
    cannotDeleteGroupHasAnimals:
      "Cannot delete a group with animals. Remove all animals first.",
    animalsMoved: "{count} animals moved",
    errorDuringMove: "Error during move",
  },
  poderiLayout: {
    dbErrorTitle: "Database Error",
    dbErrorSubtitle: "A problem occurred with the local database",
    dbErrorHeading: "Unable to access the database",
    dbErrorRetry: "Retry Initialization",
  },
  poderiStore: {
    plotNotFoundOrNoGeometry: "Plot not found or missing geometry",
    onlyOwnerCanDelete: "Only the owner can delete the farm",
  },
  dbStore: {
    cannotInitDb: "Unable to initialize the DB: {message}",
    fetchDataUnauthorized:
      "Unable to fetch data. Error code 401: unauthorized.",
    fetchDataFailed: "Unable to fetch data.",
    errorCode: "Error code: {status}.",
  },
  geoElementDetail: {
    loading: "Loading...",
    notFound: "Geographic element not found.",
    survey: "Survey",
    type: "Type",
    description: "Description",
    surveysCount: "Surveys ({count})",
    noSchemaConfigured: "No survey schema configured for this element type.",
    noSurveysHint: 'No survey recorded. Use "Add" to insert the first one.',
    editSurveyTitle: "Edit Survey",
    newSurveyTitle: "New Survey",
    saving: "Saving...",
    surveyDateLabel: "Survey date",
    surveySchemaLabel: "Survey schema",
    selectSchemaPlaceholder: "Select schema",
    editGeoElementTitle: "Edit geographic element",
    back: "Back",
    next: "Next",
    saveChanges: "Save Changes",
    deleteGeoElementTitle: "Delete geographic element",
    deleteGeoElementConfirm: "Delete the geographic element",
    deletingGeoElement: "Deleting...",
    deleteSurveyTitle: "Delete survey",
    deleteSurveyConfirm: "Delete the survey from",
    notAvailable: "N/A",
    typeFallback: "Type {id}",
    schemaFallback: "Schema {id}",
    defaultTitle: "Geographic element",
  },
  useModelFarmMapLayers: {
    farmCenter: "Farm Center",
    loading: "Loading...",
    calculationError: "Calculation error",
    field: "Field",
    loadingLower: "loading...",
    errorLower: "error",
    noCultivableField: "No cultivable field",
    fields: "Fields",
    alert: "Alert",
    customGeometry: "custom geometry",
    lowRisk: "Low risk",
    attention: "Attention",
    critical: "Critical",
    notAvailable: "N/A",
  },
  useMapLayers: {
    cropsCategory: "Crops",
    noCrop: "No crop",
    typeFallback: "Type {id}",
    geoElementsCategory: "Geographic Elements",
    farmCenter: "Farm Center",
    fields: "Fields",
    area: "Area",
    type: "Type",
    crop: "Crop",
    fieldsCount: "Fields",
    customGeometry: "custom geometry",
    goToField: "Go to field",
    notAvailable: "N/A",
    geoElements: "Geographic Elements",
    description: "Description",
    goToDetail: "Go to detail",
  },
  plotMap: {
    pointsCount: "{count} points",
    editActive: "Editing Active",
    edit: "Edit",
    undo: "Undo",
    delete: "Delete",
    clickToDrawPolygon: "Click on the map to start drawing the polygon",
    clickToDrawLine: "Click on the map to start drawing the line",
    clickToPlacePoint: "Click on the map to place the point",
    enableDrawingHint: "Enter the farm center coordinates to enable drawing",
    multiPolygonSingleWarning:
      "The original geometry is a MultiPolygon with a single polygon — displayed normally.",
    multiPolygonMultiWarning:
      "The original geometry contains multiple separate polygons. Only the largest one is shown in the editor.",
    multiPolygonDataLossWarning: "Saving will discard the other polygons.",
    polygonStartTitle: "Click on the map to draw the polygon",
    polygonStartHint: "Add at least 3 points.",
    editModeLabel: "Edit mode:",
    polygonEditHint:
      'Drag vertices to move them, click to delete (min 3), drag the "+" points to insert new vertices.',
    polygonDoneTitle: "Polygon completed!",
    polygonDoneHint: 'Use "Edit" to change it or "Delete" to start over.',
    lineStartTitle: "Click on the map to draw the line",
    lineStartHint: "Add at least 2 points.",
    lineEditHint:
      'Drag vertices to move them, click to delete (min 2), drag the "+" points to insert new vertices.',
    lineDoneTitle: "Line completed!",
    lineDoneHint: 'Use "Edit" to change it or "Delete" to start over.',
    pointStartTitle: "Click on the map to place the point",
    pointDoneTitle: "Point placed.",
    pointDoneHint:
      "Drag the marker to move it or click elsewhere to reposition it.",
    centerMarkerTooltip: "Farm Center",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit fullscreen",
    confirmDeleteGeometry: "Delete the geometry?",
    otherPlotFallback: "Other plot",
  },
  usePlantMapLayers: {
    notAvailable: "N/A",
    nonExistingPositions: "Non-existing positions",
    deadPlants: "Dead plants",
    plants: "Plants",
    selection: "Selection",
    labels: "Labels",
  },
  useVoiceInput: {
    micError: "Microphone error: {error}",
    noAudioRecorded: "No audio recorded for Whisper",
    transcriptionError: "Whisper transcription error",
    micUnavailable: "Microphone unavailable or permission denied",
  },
  plantSurveyEditorView: {
    loading: "Loading...",
    noPlants: "No plants available for this plot",
    pageTitle: "Plant Surveys",
    home: "Home",
    farms: "Farms",
    surveysBreadcrumb: "Surveys",
  },
  plantSurveyViewerView: {
    pageTitle: "Survey Analysis",
    backToPlants: "Back to Plants",
    loadingData: "Loading data...",
    noSurveysAvailable: "No surveys available for this plot.",
    schema: "Schema",
    selectSchema: "Select schema...",
    variable: "Variable",
    selectVariable: "Select variable...",
    noNumericVariable: "No numeric variable in this schema",
    campaign: "Campaign",
    allCampaigns: "All campaigns",
    observationsCount: "{count} observations",
    plantsSurveyedCount: "{count} plants surveyed",
    campaignSingular: "campaign",
    campaignPlural: "campaigns",
    editData: "Edit data",
    tabMap: "Map",
    tabStats: "Statistics",
    tabRawData: "Raw data",
    sum: "Sum",
    values: "Values",
    mapMode: "Map mode",
    rowColHeader: "↓ Row / Col →",
    cellTooltipNumeric: "Row {row}, Col {col} — mean: {mean} (n={count})",
    cellTooltipValue: "Row {row}, Col {col} — {value}",
    noData: "No data",
    noPlant: "No plant",
    spatialMapCaption: "Spatial map — {schema} · {variable}",
    noMapData: "No data available for the map",
    totalN: "Total N",
    mean: "Mean",
    stdDev: "Std Dev",
    median: "Median",
    outliers: "Outliers",
    date: "Date",
    total: "Total",
    editThisDate: "Edit this date",
    outlierValues: "Outlier values:",
    perVariety: "By variety",
    variety: "Variety",
    noNumericData: "No numeric data available",
    rowsCount: "{count} rows",
    downloadCSV: "Download CSV",
    home: "Home",
    farms: "Farms",
    dateSingular: "date",
    datePlural: "dates",
    schemaFallback: "Schema {id}",
    schemaOptionLabel: "{name} — {count} surveys",
    row: "Row",
    column: "Column",
    plantTag: "Plant tag",
    accession: "Accession",
  },
};
